export default {
  EnvironmentType: {
    Dev: 0,
    SIT: 1,
    UAT: 2,
    Staging: 3,
    Production: 4,
  },
  ApplicationStoreType: {
    Peak: 0,
    NewPeak: 1,
    Payroll: 2,
    Board: 3,
    Asset: 4,
    Tax: 5,
  },
  userType: {
    email: 0,
    google: 1,
  },
  TypeComponentNoti: {
    success: "success",
    warn: "warn",
    error: "error",
    upload: "upload",
  },
  LoadingStatusType: {
    None: 0,
    Loading: 1,
    Success: 2,
    Failed: 3,
  },
  ETaxDataStatus: {
    Send: 0,
    Void: 1,
  },
  EtaxFileDownloadType: {
    None: 0,
    PDF: 1,
    PDFA3: 2,
    XML: 3,
  },
  TypeInputSummaryProduct: {
    ThisMount: 0,
    BeforeMount: 1,
    YearToDate: 2,
  },
  BankType: {
    None: 0,
    CurrentAccount: 1,
    SavingAccount: 2,
    FixedDeposit: 3,
  },
  PaymentInOutFlowType: {
    None: 0,
    CashIn: 1,
    CashOut: 2,
  },
  ChangeFormType: {
    None: 0,
    DayOnDay: 1,
    WeakOnWeak: 2,
    MonthOnMonth: 3,
    QuarterOnQuarter: 4,
    YearOnYear: 5,
  },
  TransactionType: {
    None: 0,
    Quotation: 1,
    Invoice: 2,
    Receipt: 3,
    TaxInvoice: 4,
    CreditNote: 5,
    BillingNote: 6,
    DebitNote: 7,
    PP30: 8,
    Pnd53: 9,
    Pnd3: 10,
    Dailyjournal: 11,
    WithholdingTax: 12,
    Payroll: 13,
    TaxPP30: 14,
    TaxPND53: 15,
    TaxPND3: 16,
    TaxPND1: 17,
    TaxPND2: 18,
  },
  TransactionDocumentType: {
    None: 0,
    Quotation: 1,
    Invoice: 2,
    Receipt: 3,
    TaxInvoice: 4,
    CreditNote: 5,
    BillingNote: 6,
    DebitNote: 7,
    PP30: 8,
    Pnd53: 9,
    Pnd3: 10,
    Dailyjournal: 11,
    WithholdingTax: 12,
    Payroll: 13,
    TaxPP30: 14,
    TaxPND53: 15,
    TaxPND3: 16,
    Pnd1: 17,
    Pnd2: 18,
    Envelope: 19,
  },
  InvoiceReferenceType: {
    None: 0,
    Quotation: 1,
    PP30: 8,
    Pnd53: 9,
    Pnd3: 10,
    Payroll: 13,
    TaxPP30: 14,
    TaxPND53: 15,
    TaxPND3: 16,
  },
  FinanceType: {
    None: 0,
    InFlow: 1,
    OutFlow: 2,
  },
  ExpenseType: {
    None: 0,
    Expense: 1,
    PurchaseInventory: 2,
    PurchaseAsset: 3,
  },
  EncodeExpenseType: {
    InFlow: 0,
    OutFlow: 1,
  },
  TransactionItemType: {
    None: 0,
    Service: 1,
    Inventory: 2,
    Asset: 3,
  },
  IssuedTransactionType: {
    None: 0,
    IssuedTransaction: 1,
    Paid: 2,
    WaitingPaid: 3,
    Overdue: 4,
    EtaxInvoive: 5,
    Outstanding: 6,
    GotTaxInvoice: 7,
    AwaitTaxInvoice: 8,
    Accepted: 9,
    Expired: 10,
    AwaitReceipt: 11,
  },
  InvoiceRemainPaymentSummaryType: {
    None: 0,
    Day: 1,
    Month: 2,
    Year: 3,
  },
  repoetType: {
    None: 0,
    Quotation: 1,
    PurcahseOrder: 2,
    Invoice: 3,
    InvoiceAllProduct: 4,
    Expense: 5,
    ExpenseAllProduct: 6,
    PurchaseAsset: 7,
    PurchaseAssetAllProduct: 8,
    Receipt: 9,
    StockActivityStockCardMovement: 10,
    TaxInvoice: 11,
    TaxInvoiceInRevenueDepartmentFormat: 12,
    TrialBalanceWithSubAccount: 13,
    TrialBalance: 14,
    PurcahseTaxInvoice: 15,
    PurchaseTaxInvoiceInRevenueDepartFormat: 16,
    Journal: 17,
    BillingNoteInvoice: 18,
    BillingNoteInvoiceAllInvoice: 19,
    BillingNoteExpense: 20,
    BillingNoteExpenseAllExpense: 21,
    Finance: 22,
    PP30InputVat: 23,
    PP30OutputVat: 24,
    CreditNote: 25,
    CreditNoteExpense: 26,
    AssetTemplateGroup: 27,
    AssetTemplate: 28,
    WithHeldTax: 29,
    WithHoldingTax: 30,
    GeneralLedgerTransaction: 31,
    AllGeneralLedger: 32,
    AllGeneralLedgerWithSubAccount: 33,
    AgingReportAR: 34,
    AgingReportAP: 35,
    Product: 36,
    ProfitLoss: 37,
    ChartOfAccount: 38,
    BalanceSheet: 39,
    Unit: 40,
    ReportDocument: 41,
    Asset: 42,
    StatementEFiling: 43,
    AllReport: 44,
    Contact: 45,
    PurchaseTaxInvoiceNotUse: 46,
    SalesTaxInvoiceNotUse: 47,
    PP30TaxFilingTextFile: 48,
    WithHoldingTaxPND2: 49,
    WithHoldingTaxPND3: 50,
    WithHoldingTaxPND53: 51,
    CashflowStatementReport: 52,
    AllReportSalesByCustomerReport: 53,
    AllReportSalesByAccountReport: 54,
  },
  DocumentType: {
    None: 0,
    Create: 1,
    Edit: 2,
  },
  ContactType: {
    None: 0,
    Create: 1,
    Edit: 2,
  },
  AllocationType: {
    None: 0,
    Create: 1,
    Edit: 2,
  },
  AllocationItemType: {
    None: 0,
    Create: 1,
    Edit: 2,
  },
  SortOption: {
    none: 0,
    descending: 1,
    ascending: 2,
  },
  WhtAmountType: {
    Auto: { value: null, type: -3 },
    NotSpecify: { value: null, type: -2 },
    None: { value: 0, type: -1 },
    Custom: { value: 0, type: 0 },
    ZeroPointSevenFive: { value: 0.75, type: 1 },
    OnePercent: { value: 1, type: 2 },
    TwoPercent: { value: 2, type: 3 },
    ThreePercent: { value: 3, type: 4 },
    FivePercent: { value: 5, type: 5 },
    TenPercent: { value: 10, type: 7 },
    FifteenPercent: { value: 15, type: 8 },
    OnePointFivePercent: { value: 1.5, type: 9 },
    BackEndAuto: { value: null, type: 10 },
  },
  LanguageType: {
    Thai: "th",
    English: "en",
  },
  Language: {
    None: 0,
    Thai: 1,
    English: 2,
  },
  ModalCreateType: {
    Basic: 1,
    Advance: 2,
  },
  ProductType: {
    None: 0,
    Inventory: 1,
    Service: 2,
  },
  importDocumentType: {
    Document: 1,
    ItemInDocument: 2,
  },
  ImportDocumentCreateStatus: {
    Error: 1,
    Duplicated: 2,
    Success: 3,
    Failed: 4,
  },
  ImportTransactionType: {
    None: 0,
    Quotation: 1,
    Invoice: 2,
    Receipt: 3,
    PurchaseOrder: 4,
    PurchaseInventory: 5,
    Expense: 6,
    ReceiptFromInvoice: 7,
    ReceiptFromQuotation: 8,
    InvoiceFromQuotation: 9,
    Journal: 10,
  },
  ImportEcommerceType: {
    Shopee: 0,
    Lazada: 1,
    TikTokShop: 2,
    FoodStory: 3,
  },
  FoodStoryBankAccountType: {
    None: 0,
    Cash: 1,
    DebitCreditCard: 2,
    BankTransfer: 3,
    PromptPay: 4,
    AliPayLINEPayWeChat: 5,
    Other: 6,
  },
  ImportEcommerceIssueDateType: {
    OrderDate: 0,
    PayemntDate: 1,
    ShippingDate: 2,
  },
  ImportTableViewStatusType: {
    All: 0,
    Quotation: 1,
    Invoice: 2,
    Receipt: 3,
    PurchaseOrder: 4,
    PurchaseInventory: 5,
    IsDeleted: 6,
    Expense: 7,
    ReceiptFromInvoice: 8,
    ReceiptFromQuotation: 9,
    InvoiceFromQuotation: 10,
    Journal: 11,
  },
  TransactionTableViewStatusType: {
    All: 0,
    Draft: 1,
    AwaitApproval: 2,
    WaitingPayment: 3,
    OverDue: 4,
    Paid: 5,
    AwaitTaxInvoice: 6,
    GotTaxInvoice: 7,
    Voided: 8,
    EtaxInvoiceIssued: 9,
    AwaitReceipt: 10,
    GotReceipt: 11,
  },
  BillingNoteTableViewStatusType: {
    All: 0,
    Draft: 1,
    AwaitApproval: 2,
    WaitingPayment: 3,
    Overdue: 4,
    Paid: 5,
    Voided: 6,
  },

  ImportTableView: {
    id: 0,
    code: 1,
  },
  ContactTableViewStatusType: {
    All: 0,
    Achieved: 1,
    CustomGroup: 2,
    ContactCustomer: 3,
    ContactSeller: 4,
  },
  BillingNoteTableView: {
    id: 1,
    number: 2,
    date: 3,
    dueDate: 4,
    netAmount: 5,
  },
  ContactTableView: {
    id: 0,
    code: 1,
    name: 2,
    email: 3,
    accountPayable: 4,
    accountReceivable: 5,
  },
  ProductTableViewStatusType: {
    All: 0,
    Product: 1,
    Service: 2,
    Achieved: 3,
  },
  ProductTableView: {
    id: 0,
    code: 1,
    name: 2,
    totalSellPrice: 3,
    totalPurchasePrice: 4,
    purchaseAvgPrice: 5,
    sellAvgPrice: 6,
    remainAmount: 7,
  },
  AllocationGroupTableView: {
    none: 0,
    id: 1,
    number: 2,
    name: 3,
    allocationItemCount: 4,
    allocationDocumentFinanceType: 5,
    isArchived: 6,
  },
  AllocationItemTableView: {
    none: 0,
    id: 1,
    number: 2,
    name: 3,
    deascription: 4,
    isArchived: 6,
  },
  ProductTemplateType: {
    None: 0,
    Product: 1,
    Service: 2,
  },
  TableSorting: {
    DESC: 0,
    ASC: 1,
  },
  TableSortingType: {
    Amount: 0,
    Date: 1,
  },
  WhtDeductType: {
    None: 0,
    WitholdAtSource: 1,
    PayEveryTime: 2,
    PayOneTime: 3,
  },
  PaymentOption: {
    None: 0,
    Standard: 1,
    Advance: 2,
  },
  DiscountType: {
    Currency: 0,
    Percent: 1,
  },

  CurrencyCode: {
    THB: 0,
    USD: 1,
    GBP: 2,
    EUR: 3,
    JPY: 4,
    HKD: 5,
    MYR: 6,
    SGD: 7,
    BND: 8,
    PHP: 9,
    IDR: 10,
    INR: 11,
    CHF: 12,
    AUD: 13,
    NZD: 14,
    CAD: 15,
    SEK: 16,
    DKK: 17,
    NOK: 18,
    CNY: 19,
    MXN: 20,
    ZAR: 21,
    KRW: 22,
    TWD: 23,
    KWD: 24,
    SAR: 25,
    AED: 26,
    MMK: 27,
    BDT: 28,
    CZK: 29,
    KHR: 30,
    KES: 31,
    LAK: 32,
    RUB: 33,
    VND: 34,
    EGP: 35,
    PLN: 36,
    LKR: 37,
    IQD: 38,
    BHD: 39,
    OMR: 40,
    JOD: 41,
    QAR: 42,
    MVR: 43,
    NPR: 44,
    PGK: 45,
    ILS: 46,
    HUF: 47,
    PKR: 48,
  },

  TaxTypeId: {
    None: 2,
    ExcludeTax: 0,
    IncludeTax: 1,
  },
  BankAccountType: {
    Cash: 0,
    Bank: 1,
    ExpenseClaim: 2,
    WithheldTax: 3,
    WithholdingTax: 4,
    EWallet: 5,
  },

  BankReferenceType: {
    NONE: -1,
    OTHER: 0,
    BBL: 1,
    KBANK: 2,
    SCB: 3,
    SME: 4,
    KTB: 5,
    BAY: 6,
    KK: 7,
    CIMB: 8,
    TMB: 9,
    TISCO: 10,
    TCR: 11,
    TCAP: 12,
    BAAC: 13,
    EXIM: 14,
    UOB: 15,
    LHBANK: 16,
    SCBT: 17,
    GSB: 18,
    IBANK: 20,
    ICBC: 21,
    JPMORGAN: 22,
    CITIBANK: 23,
    SMBC: 24,
    DB: 25,
    BNP: 26,
    MIZUHO: 27,
    THAIPR: 28,
    BOC: 29,
    BOA: 30,
    RBS: 31,
    RHB: 32,
    IOB: 33,
    HSBC: 34,
    ANZ: 35,
    OCBC: 36,
    GHBANK: 37,
  },

  EWalletProvider: {
    None: 0,
    TwoCTwoP: 1,
    Omise: 2,
    TrueWallet: 3,
    LinePayOrWePay: 4,
    PayPal: 5,
    PaySolutions: 6,
    GBPrimePay: 7,
    Lazada: 8,
    Shopee: 9,
    JDDotCom: 10,
    Grab: 11,
    FoodPanda: 12,
    LineMan: 13,
    Lalamove: 14,
    Robinhood: 15,
    BigThailand: 16,
    Stripe: 17,
    Payoneer: 18,
    BeamDeFiAndCrypto: 19,
    TikTokShop: 20,
    MPay: 21,
    HDmall: 22,
    WalletAtPost: 23,
    BeamCheckout: 24,
  },

  EWalletPaymentGatewayType: {
    None: 0,
    NonBank: 1,
    ECommerce: 2,
  },
  ExcludedAccountCodeFromCreateTransaction: {
    Cash: 111101,
    CurrentAccounts: 111201,
    SavingAccounts: 111301,
    UncashedCheques: 111401,
    FixedDeposites: 112101,
    AccountsReceivable: 113101,
    ChequesReceivedInAdvance: 113102,
    AccountsPayable: 212101,
    ChequesPayable: 212102,
    EWallet: 111501,
  },
  ChartaccountPaymentNotDisplayPayment: {
    Cash: 111101,
    BankCurrentAccount: 111201,
    BankSavingsAccount: 111301,
    CheckDueButNotDeposited: 111401,
    BankFixedDeposit: 112101,
    OtherTemporaryInvestments: 112201,
    TradeReceivables: 113101,
    CheckInAdvance: 113102,
    Materials: 114101,
    InstantProducts: 114102,
    WorkInProcess: 114103,
    BankOverdrafts: 211101,
    TradePayables: 212101,
    CheckPaid: 212102,
    NonRefundableInterestPayment: 212203,
    Land: 124101,
    ConstructionWork: 124102,
    Building: 124103,
    BuildingRenovation: 124104,
    MachineryAndEquipment: 124105,
    OfficeEquipment: 124106,
    OfficeFurnishings: 124107,
    Vehicle: 124108,
    AccumulatedDepreciationBuilding: 124203,
    AccumulatedDepreciationBuildingImprovements: 124204,
    CumulativeDepreciationMachinery: 124205,
    AccumulatedDepreciationOfficeEquipment: 124206,
    AccumulatedDepreciationOfficeSupplies: 124207,
    AccumulatedDepreciationVehicles: 124208,
    Software: 125101,
    LeaseOrUseOfProperty: 125102,
    OtherIntangibleAssets: 125103,
    AccumulatedAmortizationSoftware: 125201,
    AccumulatedAmortizationLeaseholdOrUseRights: 125202,
    AccumulatedAmortizationOtherIntangibleAssets: 125203,
    DepreciationBuilding: 530703,
    DepreciationBuildingImprovements: 530704,
    DepreciationOfficeEquipment: 530706,
    DepreciationOfficeFurniture: 530707,
    DepreciationVehicles: 530708,
    AmortizationSoftware: 530801,
    AmortizationLeaseholdOrUseOfAssets: 530802,
    AmortizationฯtherIntangibleAssets: 530803,
    DepreciationMachinery: 510102,
    InvestmentInAssociatedCompany: 121102,
    InvestmentsInSubsidiaries: 121103,
    InvestmentsInJointVentures: 121104,
    OtherLongTermInvestments: 121105,
    LongTermLoansToRelatedParties: 122101,
    LongTermLoansToOtherPersons: 122102,
    InvestmentProperty: 123101,
    NonCurrentAssetsHeldForSale: 123201,
    EWallet: 111501,
  },
  AccountDefaultForEWalletType: {
    DefaultEWallet: 111501,
    TermInvestments: 1122,
    RelatedParties: 1132,
    OtherReceivables: 1133,
    AdvancePaymentsInventory: 1151,
    AdvancePaymentsToEmployee: 1152,
    AccruedRevenue: 1153,
    UnsecuredLoans: 2122,
    OtherPayables: 2123,
  },
  DueDateSettingType: {
    None: 0,
    DateDistanct: 1,
    DateDistanctNextMonth: 2,
    EndOfMonth: 3,
    EndOfMonthFromNextMonth: 4,
  },
  ProductVatType: {
    NotDefined: 0,
    None: 1,
    ZeroPercent: 2,
    SevenPercent: 3,
  },
  ImportType: {
    NotDefined: 0,
    Excel: 1,
    ECommerce: 2,
  },
  ImportStatus: {
    Error: -3,
    Draft: -2,
    AwaitApproval: -1,
    OnProcess: 0,
    Approve: 1,
  },
  TransactionExpenesStatus: {
    Draft: -2,
    AwaitApproval: -1,
    Approve: 0,
    Paid: 1,
  },
  JournalType: {
    None: 0,
    PurchaseJournal: 1,
    SalesJournal: 2,
    PaymentJournal: 3,
    ReceiveJournal: 4,
    GeneralJournal: 5,
  },
  JournalAccountReferenceType: {
    None: 0,
    Contact: 1,
    ProductTemplate: 2,
    BankAccount: 3,
    Cheque: 4,
    FixAssetTemplate: 5,
  },
  PrimaryForDDL: {
    CurrentAssets: 1,
    NonCurrentAssets: 2,
    CurrentLiabilities: 3,
    NonCurrentLiabilities: 4,
    Equity: 5,
    Revenues: 6,
    Expenses: 7,
  },
  UnitType: {
    None: 0,
    Product: 1,
    Service: 2,
    FixedAsset: 3,
  },
  JournalStatusType: {
    AwaitRecord: -3,
    Draft: -2,
    AwaitApproval: -1,
    Approved: 0,
  },
  LockStatusType: {
    Unlock: 0,
    LockByUser: 1,
    LockBySystem: 2,
    LockByPeriod: 3,
  },
  ChartOfAccountTableStatusType: {
    All: 0,
    Assets: 1,
    Liabilities: 2,
    Equity: 3,
    Revenues: 4,
    Expenses: 5,
  },
  ChartOfAccountTableView: {
    Code: 1,
    Name: 2,
  },
  JournalTableViewStatusType: {
    All: 0,
    AwaitRecord: 1,
    Draft: 2,
    Purchase: 3,
    Sales: 4,
    Payment: 5,
    Receive: 6,
    General: 7,
    Voided: 8,
    ShouldBeCheck: 9,
    AwaitApprove: 10,
  },
  JournalTableView: {
    id: 0,
    number: 1,
    date: 2,
    debit: 3,
    credit: 4,
    journalType: 5,
    description: 6,
  },
  CashBankTableView: {
    id: 0,
    date: 1,
  },
  ChequeTableViewStatus: {
    id: 0,
    chequeCode: 1,
    receivedDate: 2,
    contactName: 3,
    transactionNumber: 4,
    chequeTotal: 5,
  },
  TaxIncomeType: {
    None: 0,
    TaxIncomeType40_1_1: 1,
    TaxIncomeType40_1_2: 2,
    TaxIncomeType40_12: 3,
    TaxIncomeType40_2: 4,
    TaxIncomeType40_3: 5,
    TaxIncomeType40_4_A: 6,
    TaxIncomeType40_4_B: 7,
    TaxIncomeType40_4_C: 8,
    TaxIncomeType40_4_D: 9,
    TaxIncomeType40_4_E: 10,
    TaxIncomeType40_4_F: 11,
    TaxIncomeType40_4_G: 12,
    TaxIncomeType40_5: 13,
    TaxIncomeType40_6: 14,
    TaxIncomeType40_7: 15,
    TaxIncomeType40_8_1: 16,
    TaxIncomeType40_8_2: 17,
    TaxIncomeType40_8_3: 18,
    TaxIncomeType40_8_4: 19,
    TaxIncomeType40_8_5: 20,
    TaxIncomeType40_8_6: 21,
    TaxIncomeType40_8_7: 22,
    TaxIncomeType40_8_8: 23,
  },
  LockStatus: {
    Unlock: 0,
    LockByUser: 1,
    LockBySystem: 2,
    LockByPeriod: 3,
  },
  HttpStatusCode: {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    OK: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    IMUsed: 226,
    Ambiguous: 300,
    MultipleChoices: 300,
    Moved: 301,
    MovedPermanently: 301,
    Found: 302,
    Redirect: 302,
    RedirectMethod: 303,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    RedirectKeepVerb: 307,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    RequestEntityTooLarge: 413,
    RequestUriTooLong: 414,
    UnsupportedMediaType: 415,
    RequestedRangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
  },
  CreditNoteStyleType: { General: 0, ThaiPopular: 1 },
  PeakExceptionResponseCode: {
    None: 0,
    TransactionNumberDuplicated: 1,
    ContactNotFound: 2,
    ProductNotFound: 3,
    AccountNotFound: 4,
    LockByPeriod: 5,
    FreePackageOverCreateTransaction: 6,
    ProPlusImportTransaction: 7,
    FullPaymentAmount: 8,
    InputFieldEmptry: 9,
    TransactionIsVoided: 10,
    OverPaid: 11,
    ProductNameAndDescriptionIsDuplicated: 12,
    ProductTemplateCodeIsDuplicated: 13,
    AccountCodeIsDuplicated: 14,
    UnitCodeIsDuplicated: 15,
    BankAccountCodeIsDuplicated: 16,
    ContactCodeIsDuplicated: 17,
    TaxIdIsDuplicated: 18,
    ContactNameIsDuplicated: 19,
    IssuedTaxInvoiceDuplicated: 20,
    PaymentIsDeleted: 21,
    ApprovedTransactionDuplicated: 22,
    AcceptedQuotationDuplicated: 23,
    CanNotVoidInvoiceIsIssuedBillingNote: 24,
    CanNotVoidInvoiceIsIssuedCreditNote: 25,
    CanNotVoidReceiptIsIssuedCreditNote: 26,
    LockByUser: 27,
    LockBySystem: 28,
    LockByIssuedPP30: 29,
    LockBySendEtaxInvoice: 30,
    CanNotVoidQuotationIsIssuedInvoice: 31,
    CanNotVoidQuotationIsIssuedReceipt: 32,
    CanNotCreateDuplicatedReceiptFromReferenceTransaction: 33,
    IssuedDuplicatedTaxInvoice: 34,
    ReceivedTaxInvoiceVatTotalOverflow: 35,
    ReceivedTaxInvoicePreVatTotalOverflow: 36,
    UserProfileIsAlready: 37,
    EmailPasswordIncorrect: 38,
    ContactIdBelongToMerchant: 39,
    MerchantIsVerified: 40,
    ReceivedTaxInvoiceNumberDuplicated: 41,
    DuplicateNameContactGroup: 42,
    ImportTransactionExceed: 43,
    IsHaveUserInSystem: 44,
    DuplicatedReferFriends: 45,
    DuplicateFileName: 46,
    CanNotVoidInvoiceIsIssuedDebitNote: 47,
    CanNotVoidReceiptIsIssuedDebitNote: 48,
    BankAccountNotFound: 49,
    OverInvitationUser: 50,
    UserAlreadyMerchant: 51,
    MerchantPackageIsNotAddUser: 52,
    CanNotEditSuperUser: 53,
    UserUpdateEqualEditUser: 54,
    CanNotRemoveSuperUser: 55,
    CanNotRemoveUser: 56,
    DuplicatedSettingNumberIndextString: 57,
    AuthorityRoleNotPermission: 58,
    NotHavePermissionUser: 59,
    NotHavePermissionFinance: 60,
    NotHavePermissionPayroll: 61,
    NotHavePermissionPeakBoard: 62,
    ApiPartnerNotFound: 63,
    MerchantIsNotAllowDuplicateContact: 64,
    CanNotDeleteThisFinance: 65,
    CanNotVoidAllocation: 66,
    CanNotVoidAllocationItem: 67,
    CanNotIsArchivedAllocationIncome: 68,
    CanNotIsArchivedAllocationExpense: 69,
    LockByIssuedPND3: 70,
    LockByIssuedPND53: 71,
    CanNotEditDocumentIsIssuedFromPayroll: 72,
    CreditLimitCannontCreate: 73,
    CreditLimitWarning: 74,
    CanNotVoidPaymentIsIssuedReceipt: 75,
    InvalidDocumentPassCode: 76,
    CanNotEditInvoiceIsIssuedDebitNote: 77,
    CanNotEditInvoiceIsIssuedCreditNote: 78,
    CanNotEditJournal: 79,
    CanNotUpdateJournalStatus: 80,
    CanNotVoidProductTemplate: 81,
    ProductTemplateNameCanNotEmpty: 82,
    CanNotAddNewPriceToProductService: 83,
    ProductServicePriceNameDuplicated: 84,
    InvalidINetAuthenticationData: 85,
    AssetPurchaseDateLessThanStopAssetDepreciationDate: 86,
    PackageErrorCode: 87,
    UpgradeToPackageErrorCode: 88,
    AssetTemplateCodeDuplicated: 89,
    CanNotEditTransactionAsset: 90,
    CanNotVoidAssetTemplateBecauseAssetTemplateIssuedAsset: 91,
    CanNotVoidAssetBecauseAssetIssuedByPurchaseAsset: 92,
    CanNotVoidAssetBecauseAssetIssuedBySaleAsset: 93,
    OverLimitAsset: 94,
    BillingTransactionCurrencyNotCorrect: 95,
    DuplicatedReceiveBillingNoteNumber: 96,
    CanNotSaleAssetBecauseDoesNotSelectAssetId: 97,
    CanNotSaleAssetBecauseSaleAssetDateLessThanStopDepreciationDate: 98,
    IsNotHaveContactRevenueDepartment: 99,
    IsNotHaveContactSalary: 100,
    IsNotHaveContactSSO: 101,
    CantDoPaymentIsHaveErrorPndType: 102,
    CanNotVoidUnit: 103,
    ChequeisreceivedandChequeisclearing: 104,
    ChartOfAccountCannotDeleted: 105,
    UserIsInSystemAlready: 106,
    UserNotFound: 107,
    InvitationIncorrect: 108,
    InvitationIncorrectOrExpired: 109,
    AssetTemplateIsDeleted: 110,
    OverCreditNoteAmount: 111,
    OverPaymentCreditNoteAmount: 112,
    CanNotCreateCreditNote: 113,
    CreditNoteDateLessThanReferenceTransactionDate: 114,
    CanNotVoidTransactionIsHaveReferenceDocumentPayment: 115,
    OverPaidReferenceDocumentPayment: 116,
    IsReferenceTransactionIssuedCreditNote: 117,
    IssueCreditNoteAmountOverReferenceCreditNote: 118,
    CannotVoidPaymentHavePND: 119,
    CanNotEditTransactionIsIssuedReferencePaymentDocument: 120,
    CanNotEditTransactionIsIssuedPayment: 121,
    CanNotCreateCreditNoteBecauseTransactionRefIsIssuedDebitNote: 122,
    CanNotCreateCreditNoteBecauseTransactionRefIsNoDebt: 123,
    CanNotCreateDebitNoteBecauseTransactionRefIsIssuedCreditNote: 124,
    CanNotGotReceiptBecauseNotHavePayment: 125,
    CanNotVoidBillingNoteBecausePaid: 126,
    BillingAmountCannotBeGreaterThanOutstandingBalanceOfTheDocument: 127,
    CanNotBePaid: 128,
    AccountingFirmDeleted: 129,
    NotHaveAfpRefCode: 130,
    AccountingFirmRegisted: 131,
    NotHaveAccountingFirmMerchant: 132,
    AccountingFirmMerchantDeleted: 133,
    InvalidPage365AuthenticationData: 134,
    DuplicatedSaleAsset: 135,
    ValidateProductMustHaveAccountId: 136,
    JournalModelNotFound: 137,
    JournalAccountDescriptionIsEmptryOrNull: 138,
    ValidateAssetMustHaveAccountId: 139,
    ProPlusRecurringTransaction: 140,
    ProBillingNote: 141,
    BankAccountNumberIsAllowDuplicate: 142,
    BasicCreateJournal: 143,
    InvalidBentoWebAuthenticationData: 144,
    NotHavePurchaseAccountAndSellAccountForProductTemplate: 145,
    InvalidLineMyShopAuthenticationData: 146,
    CanNotCreateCreditNoteBecauseReferenceTransactionTypeAsset: 147,
    CanNotCreateDebitNoteBecauseReferenceTransactionTypeAsset: 148,
    AccumulatedDepreciationMustBeLessThanassetvalue: 149,
    BookValueMustBeHigherThanScrapValue: 150,
    CanNotVoidPayment: 151,
    CanNotRedeemCode: 152,
    RedeemOnbordingPromoCodeNotFound: 153,
    CantDoPaymentIsHaveErrorDeductType: 154,
    CanNotUpdateBecauseImageNotFound: 155,
    CanNotUpdateBecauseBankReferenceNotFound: 156,
    CanNotUpdateBecauseBankNumberIsHaveError: 157,
    CanNotUpdateBecauseRemarkIsOverLength: 158,
    CanNotUpdateOnlineviewPaymentChannelSettingBecauseUserroleNotAdmin: 159,
    CanNotDeleteContact: 160,
    CanNotCreateOrUpdatePaymentBankStatement: 161,
    NotFoundPaymentBankStatement: 162,
    CanNotVoidOrDeletePaymentBankStatement: 163,
    UnableToMakeBankReconciled: 164,
    UnableCreateDefaultDataMerchantSample: 165,
    DemoMerchantExist: 166,
    ProductTemplateIsNotHaveVatType: 167,
    InvalidShopeeAuthenticationData: 168,
    CanNotSetDueDateBeforeTransactionDate: 169,
    UnableToUndoBankReconciled: 170,
    UnableToAprroveBankReconciled: 171,
    NotFoundBankReconciled: 172,
    CannotEditProductAccountAndDescriptionBecauseTransactionItemNotMap: 173,
    CanNotAssignContactGroup: 174,
    CannotEditPaymentBecausePaymentItemNotMap: 175,
    MerchantIsNotAllowDuplicateContactTaxId: 176,
    TaxInvoiceNumberDuplicated: 177,
    ProCanImportBankStatement: 178,
    ProCanReconcile: 179,
    CanNotEditContactTransactionIsReferenceInvoice: 180,
    CanNotEditContactTransactionIsReferenceReceipt: 181,
    CanNotEditContactTransactionIsIssuedBillingNote: 182,
    CanNotEditContactTransactionIsReferenceQuotation: 183,
    CanNotEditContactTransactionIsReferenceBillingNote: 184,
    ReconciledAlready: 185,
    CanNotVoidBecauseJournalAccountIsReconciled: 186,
    InvalidLazadaAuthenticationData: 187,
    MerchantDeleteAlready: 188,
    MerchantNameNotEqual: 189,
    UserIsNotAdmin: 190,
    InvalidLightworkAuthenticationData: 191,
    QRPaymentSettingModelNotFound: 192,
    SCBQRPaymentCodeModelNotFound: 193,
    CanNotVoidBankCauseByHaveBankInSCBQR: 194,
    FreePackageNotAllowedSelectChartOfAccount: 195,
    FreePackageProductIsHaveMaximum: 196,
    FreePackageCannotCreateNewFinanceAccount: 197,
    FreePackageCannotCreateNewAccount: 198,
    PackageNotFound: 199,
    CanNotCreateContactHaveMaximumContact: 200,
    CanNotCreateContactPersonHaveMaximum: 201,
    FreePackageNotAllowedAttachFile: 202,
    CanNotCreateDocumentsDatingBackUpToTwoMonths: 203,
    CanNotEditJounalBecauseFreePackage: 204,
    CantPaidPaymentSCBQRCauseByBankAccountNotFound: 205,
    CanNotIssuedTaxInvoiceNotVat: 206,
    CantPaidPaymentSCBQRCauseByAccountModelNotFound: 207,
    CantPaidPaymentSCBQRCauseByQRPaymentSettingModelNotFound: 208,
    CantPaidPaymentSCBQRCauseBySettingSCBPaymentCodeModelNotFound: 209,
    CantPaidPaymentSCBQRCauseByBankAccountNotSet: 210,
    TransactionNewStatusCannotLessThanCurrentStatus: 211,
    TransactionCurrentStatusCannotBeRejected: 212,
    CanNotCreateBecauseHaveRecordZeroAmount: 213,
    CanNotCreateBecauseNotSupportMultipleBankAccount: 214,
    CanNotEditRecordDeleted: 215,
    NotHavePermissionAsset: 216,
    QuotationCreatedTransaction: 217,
    QuantityOverQuotation: 218,
    PriceOverQuotation: 219,
    CanNotEditInvoiceBecauseDocumentHasBeenReferredToOtherDocument: 220,
    ContactPersonNamePrefixOtherMaxLength: 221,
    ContactNamePrefixOtherMaxLength: 222,
    SkuCodeIsDuplicate: 223,
    CanNotEditQuantityTransactionReferenceQuotation: 224,
    CanNotEditPriceTransactionReferenceQuotation: 225,
    CanNotAddNewTransactionItemReferenceQuotation: 226,
    CanNotSendEmail: 228,
    BankReconcileIsAlready: 229,
    CanNotPaidPaymentSCBQRCauseByNotYetPaid: 230,
    NotFoundSCBQRCodeDataModel: 231,
    JournalItemReferenceTypeInValid: 232,
    JournalItemAccountInValid: 233,
    AffiliateAccountNotFound: 234,
    CannotCreateReceivedTaxInvoiceCauseByDocumentEdited: 235,
    CanNotVoidDocumentIsDeleted: 236,
    CanNotVoidDocumentIsReferenceTransaction: 237,
    CanNotUpdateDocumentIsDeleted: 238,
    CanNotUpdateDocumentIsReferenceTransaction: 239,
    CanNotCreateCreditNoteBecauseReferenceBillingNote: 240,
    CanNotCreateDebitNoteBecauseReferenceBillingNote: 241,
    LimitProductImage: 242,
    UnableToAddPEAKSupport: 247,
  },
  AppConnectExceptionResponseCode: {
    Success: 0,
    GeneralError: 1,
    AuthorizeError: 2,
    Page365Error: 3,
    BentoWebError: 4,
    LineMyShopError: 5,
    ShopeeError: 6,
    LazadaError: 7,
    SCB: 8,
    LightworkError: 9,
    MatchLinkError: 10,
    UserError: 11,
    MerchantError: 12,
    PaySolutionError: 13,
  },
  AppConnectAuthorizeErrorCode: {
    None: 0,
    Default: 1,
    UnauthorizeRole: 2,
  },
  Page365ErrorCode: {
    None: 0,
    Default: 1,
    InvalidToken: 2,
    UnauthorizeToken: 3,
    UnauthorizeConfigToken: 4,
    DuplicateShop: 5,
  },
  BentoWebErrorCode: {
    None: 0,
    Default: 1,
    InvalidToken: 2,
    InvalidProductVariant: 3,
    UnauthorizeConfigToken: 4,
  },
  LineMyShopErrorCode: {
    None: 0,
    Default: 1,
    InvalidAccessToken: 2,
  },
  ShopeeErrorCode: {
    None: 0,
    Default: 1,
    InvalidAccessToken: 2,
    UnauthorizeConfigToken: 3,
    DuplicateShop: 4,
  },
  LazadaErrorCode: {
    None: 0,
    Default: 1,
    InvalidAccessToken: 2,
    UnauthorizeConfigToken: 3,
    DuplicateShop: 4,
  },
  MatchLinkErrorCode: {
    None: 0,
    Default: 1,
    Unauthorize: 2,
    Claimed: 3,
    NotAcceptAgreement: 4,
    InvalidOrMissingVerificationData: 5,
  },
  LightworkErrorCode: {
    None: 0,
    Default: 1,
    InvalidAccessToken: 2,
    CannotGetBankData: 3,
    CannotGetTokenData: 4,
    IncorrectTokenOrMerchantId: 5,
  },
  SCBErrorCode: {
    None: 0,
    Default: 1,
    InvalidToken: 2,
    CantInsertSCBQRPaymentCauseByHaveBillerId: 3,
    CantGetSCBQRPaymentCuaseByNotHaveBillerId: 4,
    CantGetSCBQRPaymentCuaseByNotHavePrefix: 5,
    TransactionRemainPaymentModelNotFound: 6,
    CantGetSCBQRPaymentCuaseByTransactionIdNotFound: 7,
    NotHavePayableAmount: 8,
    CantInsertSCBQRCodePaymentCauseByNotHaveBankAccountId: 9,
    SCBBankAccountNotFound: 10,
    CantGetSCBQRCodePayment: 11,
  },
  PaySolutionErrorCode: {
    None: 0,
    Default: 1,
    DontHavePaySolutionMerchantId: 2,
    DontHaveBankAccountId: 3,
    DontHaveSecretKey: 4,
    DontHaveAPIKey: 5,
    DontHaveCustomerEmail: 6,
    DataIsNull: 7,
    TransactionIdNotFound: 8,
    TransactionRemainPaymentModelNotFound: 9,
    NotHavePayableAmount: 10,
    CantGetInquiryAPI: 11,
  },
  ShopeeAuthenticationType: {
    Create: 1,
    Update: 2,
  },
  CancelledOrderType: {
    None: 0,
    IssueCreditNote: 1,
    VoidDocument: 2,
  },
  ContactDashboardForTransactionStatus: {
    Expire: -2,
    AwaitApproval: -1,
    OutstandingOrOverdue: 0,
    Approved: 1,
  },
  QuotationDatabaseStatus: {
    Draft: -2,
    AwaitApproval: -1,
    AwaitResponseOrExpired: 0,
    ApprovedOrAccepted: 1,
    CreatedTransaction: 2,
  },
  InvoiceDatabaseStatus: {
    Draft: -2,
    AwaitApproval: -1,
    OutstandingOrOverdue: 0,
    PaidOrAwaitReceipt: 1,
    GotReceipt: 2,
  },
  ReceiptDatabaseStatus: {
    Draft: -2,
    AwaitApproval: -1,
    Approved: 1,
  },
  TaxInvoiceDatabaseStatus: {
    Draft: -2,
    AwaitApproval: -1,
    Approved: 1,
  },
  CreditNoteStatus: {
    None: 0,
    Voided: 1,
    Draft: 2,
    AwaitApproval: 3,
    Approved: 4,
    Paid: 5,
  },
  CreditNoteDatabaseStatus: {
    Draft: -2,
    Approved: 0,
  },
  DebitNoteStatus: {
    None: 0,
    Voided: 1,
    Draft: 2,
    AwaitApproval: 3,
    Approved: 4,
    Paid: 5,
  },
  BillingNoteStatus: {
    None: 0,
    Voided: 1,
    Draft: 2,
    AwaitApproval: 3,
    Outstanding: 4,
    Overdue: 5,
    PaidOrAwaitReceipt: 6,
  },
  BillingNoteTableViewStatusType: {
    All: 0,
    Draft: 1,
    AwaitApproval: 2,
    WaitingPayment: 3,
    Overdue: 4,
    Paid: 5,
    Voided: 6,
  },
  BillingNoteDatabaseStatus: {
    Draft: -2,
    AwaitApproval: -1,
    OutstandingOrOverdue: 0,
    PaidOrAwaitReceipt: 1,
  },
  TransactionDetailTapId: {
    Detail: 0,
    Payment: 1,
    CreditNote: 2,
    DebitNote: 3,
    BillingNote: 4,
    History: 5,
  },
  DailyJournalDetailTapType: {
    Detail: 0,
    History: 1,
  },
  DBDEFilingDetailTapType: {
    Detail: 0,
    BalanceSheet: 1,
    IncomeStatement: 2,
    ShareholdersEquity: 3,
    History: 4,
  },
  TransactionTimelineType: {
    None: 0,
    Quotation: 1,
    AcceptedQuotation: 2,
    Invoice: 3,
    Payment: 4,
    Receipt: 5,
    TaxInvoice: 6,
    BillingNote: 7,
    CreditNote: 8,
    PurchaseOrder: 9,
    Expense: 10,
    CombinePaymentNote: 11,
    ExpensePayment: 12,
    PurchaseInventory: 13,
    PurchaseAsset: 14,
    SelectDocument: 15,
    SellAssetReceipt: 16,
    SellAssetInvoice: 17,
    PaidPayment: 18,
    DebitNote: 19,
    ReceiveCreditNote: 20,
    ReceiveDebitNote: 21,
    GotReceipt: 22,
    PurchaseOrderAsset: 23,
    SuccessQuotation: 24,
  },
  TimelineStatusType: {
    None: 0,
    Create: 1,
    Detail: 2,
    Disabled: 3,
    Active: 4,
  },
  ActionOtherType: {
    None: 0,
    Print: 1,
    Create: 2,
    Redirect: 3,
  },
  ActivityLogActionType: {
    SignIn: 1,
    SignOut: 2,
    ViewErrorPage: 3,
    SelectMerchant: 4,
    ViewIncomePage: 5,
    ViewQuotationTable: 6,
    SearchQuotationTable: 7,
    AdvanceSearchQuotationTable: 8,
    ViewCreateQuotation: 9,
    ViewCreateMerchant: 10,
    CreateMerchant: 11,
    CreateDemoMerchant: 12,
    ViewSelectList: 13,
    Register: 14,
    ResetPassword: 15,
    ForgotPassword: 16,
    RegisterWithInvitation: 17,
    ViewQuotationDetail: 18,
    CreateQuotation: 19,
    EditQuotation: 20,
    SendQuotationEmail: 21,
    ApproveQuotation: 22,
    AcceptQuotation: 23,
    SubmitDraftQuotation: 24,
    ViewInvoiceTable: 25,
    SearchInvoiceTable: 26,
    AdvanceSearchInvoiceTable: 27,
    ViewCreateInvoice: 28,
    ViewInvoiceDetail: 29,
    CreateInvoice: 30,
    EditInvoice: 31,
    PaidPayment: 32,
    SubmitDraftInvoice: 33,
    ApproveInvoice: 34,
    SendInvoiceEmail: 35,
    ViewReceiptTable: 36,
    SearchReceiptTable: 37,
    AdvanceSearchReceiptTable: 38,
    ViewCreateReceipt: 39,
    ViewReceiptDetail: 40,
    CreateReceipt: 41,
    EditReceipt: 42,
    SubmitDraftReceipt: 43,
    ApproveReceipt: 44,
    SendReceiptEmail: 45,
    ViewTaxInvoiceTable: 46,
    SearchTaxInvoiceTable: 47,
    AdvanceSearchTaxInvoiceTable: 48,
    ViewCreateTaxInvoice: 49,
    ViewTaxInvoiceDetail: 50,
    CreateTaxInvoice: 51,
    EditTaxInvoice: 52,
    SubmitDraftTaxInvoice: 53,
    ApproveTaxInvoice: 54,
    SendTaxInvoiceEmail: 55,
    UploadQuotation: 56,
    UploadInvoice: 57,
    UploadReceipt: 58,
    ArchiveIncomeTransaction: 59,
    UnarchiveIncomeTransaction: 60,
    VoidIncomeTransaction: 61,
    CreateProduct: 62,
    CreateContact: 63,
    ExportQuotationExcel: 64,
    ExportInvoiceExcel: 65,
    ExportReceiptExcel: 66,
    ExportTaxinvoiceExcel: 67,
    ViewExpensePage: 68,
    ViewPoTable: 69,
    SearchPoTable: 70,
    AdvanceSearchPoTable: 71,
    ViewCreatePo: 72,
    ViewPoDetail: 73,
    CreatePo: 74,
    EditPo: 75,
    ApprovePo: 76,
    SendPoEmail: 77,
    AcceptPo: 78,
    SubmitDraftPo: 79,
    ViewExpenseTable: 80,
    SearchExpenseTable: 81,
    AdvanceSearchExpenseTable: 82,
    ViewCreateExpense: 83,
    ViewExpenseDetail: 84,
    CreateExpense: 85,
    EditExpense: 86,
    ReceiveExpense: 87,
    PaidExpense: 88,
    SubmitDraftExpense: 89,
    ApproveExpense: 90,
    SendExpenseEmail: 91,
    ViewExpenseTaxInvoiceTable: 92,
    SearchExpenseTaxInvoiceTable: 93,
    AdvanceSearchExpenseTaxInvoiceTable: 94,
    ViewCreateExpenseTaxInvoice: 95,
    ViewExpenseTaxInvoiceDetail: 96,
    CreateExpenseTaxInvoice: 97,
    ApproveExpenseTaxInvoice: 98,
    SubmitDraftExpenseTaxInvoice: 99,
    ReceiveExpenseTaxInvoice: 100,
    SendExpenseEmailTaxInvoice: 101,
    UploadPo: 102,
    UploadExpense: 103,
    ArchiveExpenseTransaction: 104,
    UnarchiveExpenseTransaction: 105,
    VoidExpenseTransaction: 106,
    ExportPoExcel: 107,
    ExportExpenseExcel: 108,
    ExportExpenseTaxInvoiceExcel: 109,
    ViewFinancePage: 110,
    ViewCashPage: 111,
    ViewBankPage: 112,
    ViewAdvancePage: 113,
    ViewTaxedPage: 114,
    ViewTaxPage: 115,
    ViewFinanceDetailPage: 116,
    CreateBankaccount: 117,
    EditBankaccount: 118,
    EditTransferPayment: 119,
    ViewContactTable: 120,
    ViewContactDetail: 121,
    ViewEditContact: 122,
    EditContact: 123,
    SearchContactTable: 124,
    ViewCreateContactPage: 125,
    CreateContactFormCreatePage: 126,
    CreateContactGroup: 127,
    AddContactsToGroup: 128,
    ImportContacts: 129,
    ArchiveContacts: 130,
    UnarchiveContacts: 131,
    DeleteContactGroup: 132,
    ViewProductTable: 133,
    ViewProductDetail: 134,
    SearchProductTable: 135,
    EditProduct: 136,
    DeleteProduct: 137,
    ImportProducts: 138,
    AdjustProductNumber: 139,
    ViewSettingPage: 140,
    ViewUserSettingPage: 141,
    SearchUserTable: 142,
    ViewAddTeamPage: 143,
    ViewInvitationPage: 144,
    ViewUserrolePage: 145,
    ViewOrganizationPage: 146,
    UploadMerchantLogo: 147,
    EditMerchantProfile: 148,
    EditUserrole: 149,
    InviteFriend: 150,
    AddTeam: 151,
    ViewProfilePage: 152,
    ViewChangePasswordPage: 153,
    UploadProfileLogo: 154,
    EditUserProfile: 155,
    ChangeProfilePassword: 156,
    ViewOnlineViewPage: 157,
    ChangeContactGroupName: 158,
    DeleteBankAccount: 159,
    VoidInvoicePayment: 160,
    ViewDailyJournalTable: 161,
    ViewCreateDailyJournal: 162,
    CreateDailyJournal: 163,
    EditDailyJournal: 164,
    SearchDailyJournalTable: 165,
    VoidDailyJournal: 166,
    ApproveDailyJournal: 167,
    ExportDailyJournal: 168,
    ViewDailyJournalDetail: 169,
    ViewDailyJournalOnlineView: 170,
    ReRecordJournal: 171,
    ViewCreditNoteDetail: 173,
    CreateCreditNote: 174,
    UploadCreditNote: 175,
    SendCreditNoteEmail: 176,
    ViewReceiveCreditNoteDetail: 177,
    CreateReceiveCreditNote: 178,
    ViewBillingNoteDetail: 179,
    CreateBillingNote: 180,
    SendBillingNoteEmail: 181,
    EditBillingNote: 182,
    UploadBillingNote: 183,
    SubmitDraftBillingNote: 184,
    ApproveBillingNote: 185,
    ViewCombinedPaymentNoteDetail: 186,
    CreateCombinedPaymentNote: 187,
    SendCombinedPaymentNoteEmail: 188,
    EditCombinedPaymentNote: 189,
    ViewPP30Table: 190,
    ViewCreatePP30: 191,
    CreatePP30: 192,
    VoidPP30: 193,
    ViewPP30Detail: 194,
    ViewOnlineViewPP30: 195,
    EditPurchaseTaxInvoiceRefNumberAndDate: 196,
    EditReceivedCreditNoteNumberAndDate: 197,
    DraftQuotation: 198,
    SendForApproveQuotation: 199,
    DraftInvoice: 200,
    SendForApproveInvoice: 201,
    DraftReceipt: 202,
    SendForApproveReceipt: 203,
    DraftTaxInvoice: 204,
    SendForApproveTaxInvoice: 205,
    DraftPo: 206,
    SendForApprovePo: 207,
    DraftExpense: 208,
    SendForApproveExpense: 209,
    CreatePP30TextFile: 210,
    EditDocumentQuotation: 211,
    DeleteUser: 212,
    EditPaymentInvoice: 213,
    EditPaymentExpense: 214,
    EditPaymentBillingNote: 215,
    EditPaymentCombinePaymentNote: 216,
    EditPaymentCreditNote: 217,
    EditPaymentReceivedCreditNote: 218,
    EditPaymentReceipt: 219,
    SettingEmailReport: 220,
    RecalculateCostOfGoodSold: 221,
    ViewPnd53Table: 222,
    ViewCreatePnd53: 223,
    CreatePnd53: 224,
    ViewPnd53Detail: 225,
    UpdateStatusPnd53: 226,
    VoidPnd53: 227,
    VoidPnd53Payment: 228,
    ViewOnlineViewPnd53: 229,
    ViewOnlineViewPnd53FromDetail: 230,
    ViewOnlineViewPnd53FromTextFile: 231,
    VoidPP30Payment: 232,
    CreatePP30VatItemReport: 233,
    ViewPnd3Table: 234,
    ViewCreatePnd3: 235,
    CreatePnd3: 236,
    ViewPnd3Detail: 237,
    VoidPnd3: 238,
    UpdateStatusPnd3: 239,
    VoidPnd3Payment: 240,
    ViewOnlineViewPnd3FromTextFile: 241,
    ViewOnlineViewPnd3: 242,
    ViewOnlineViewPnd3FromDetail: 243,
    AttachFile: 244,
    RemoveFile: 245,
    ArchiveProducts: 246,
    UnarchiveProducts: 247,
    ViewCreditNoteTable: 248,
    ViewReceivedCreditNoteTable: 249,
    ExportCreditNoteExcel: 250,
    ExportReceivedCreditNoteExcel: 251,
    ExportBillingNoteExcel: 252,
    ExportCombinePaymentNoteExcel: 253,
    SearchCreditNoteTable: 254,
    SearchReceivedCreditNoteTable: 255,
    ViewBillingNoteTable: 256,
    ViewCombinePaymentNoteTable: 257,
    SearchBillingNoteTable: 258,
    SearchCombinePaymentNoteTable: 259,
    ViewOnlineViewCover: 260,
    EditReferenceNameCreditNote: 261,
    SendEtaxInvoiceByEmail: 262,
    SendEtaxInvoiceByBlockChain: 263,
    ReSendReferFriend: 264,
    UpdateReferFriendStatusCaseReSendEmail: 265,
    UpdateReferFriendStatusCaseRegistered: 266,
    UpdateReferFriendStatusCaseCreateMerchant: 267,
    UpdateReferrerPromotionCodeId: 268,
    SendPromotionCodeToReferrer: 269,
    ViewDebitNoteTable: 270,
    ViewCreateDebitNote: 271,
    ViewDebitNoteDetail: 272,
    CreateDebitNote: 273,
    DoRecurringTransaction: 274,
    RegisTerWithheldtaxFromCustomer: 275,
    VoidRegisTerWithheldtaxFromCustomer: 276,
    ReceiveWithholdingToSupplier: 277,
    VoidReceiveWithholdingToSupplier: 278,
    RequestVerifyOrganization: 279,
    UpdateJournalStatusAwaitRecord: 280,
    SendEtaxInvoiceByINet: 281,
    StopCalculateAssetDepreciation: 282,
    CreateChartOfAccount: 283,
    AttachFileWhtPuunReceipt: 284,
    SendApproveBillingNote: 285,
    SendWhtCertificateEmail: 286,
    UploadProfileSignature: 287,
    RegisterTaxInvoice: 288,
    VoidRegisterTaxInvoice: 289,
    DeleteChartOfAccount: 290,
    UpdateChartOfAccount: 291,
    ImportQuotation: 292,
    ImportPurchaseOrder: 293,
    ImportInvoice: 294,
    ImportExpense: 295,
    ImportReceipt: 296,
    ImportReceiptFromInvoice: 297,
    ImportReceiptFromQuotation: 298,
    ImportInvoiceFromQuotation: 299,
    ImportJournal: 300,
    UpdateUnit: 301,
    DeleteUnit: 302,
    EditCheque: 303,
    ReceivedCheque: 304,
    EditCreditNote: 305,
    DraftCreditNote: 306,
    SendForApproveCreditNote: 307,
    ApproveCreditNote: 308,
    DraftDebitNote: 309,
    EditDebitNote: 310,
    SendForApproveDebitNote: 311,
    ApproveDebitNote: 312,
    CreateReceiveDebitNote: 313,
    UploadDebitNote: 314,
    SendDebitNoteEmail: 315,
    EditPaymentDebitNote: 316,
    EditReferenceNameDebitNote: 317,
    ViewReceiveDebitNoteTable: 318,
    ViewReceiveCreateDebitNote: 319,
    ViewReceiveDebitNoteDetail: 320,
    EditPaymentReceiveDebitNote: 321,
    UploadReceiveDebitNote: 322,
    SendReceiveDebitNoteEmail: 323,
    EditReceiveDebitNote: 324,
    CannotGotReceipt: 325,
    CreateRecurringInvoice: 326,
    EditRecurringInvoice: 327,
    VoidRecurringInvoice: 328,
    ViewRecurringInvoice: 329,
    EnableRecurringInvoice: 330,
    DisableRecurringInvoice: 331,
    CreateRecurringExpense: 332,
    EditRecurringExpense: 333,
    VoidRecurringExpense: 334,
    ViewRecurringExpense: 335,
    EnableRecurringExpense: 336,
    DisableRecurringExpense: 337,
    CreateRecurringReceipt: 338,
    EditRecurringReceipt: 339,
    VoidRecurringReceipt: 340,
    ViewRecurringReceipt: 341,
    EnableRecurringReceipt: 342,
    DisableRecurringReceipt: 343,
    RejectTransaction: 344,
    DownloadUserManaulPdf: 345,
    UpdateQRPaymentSettingMerchant: 346,
    EditRemark: 347,
    EditDueDate: 348,
    EditReferenceName: 349,
    EditProductAccoundAndDescription: 350,
    EditTransactionNumber: 351,
    EditTransactionContact: 352,
    OmiseAddCard: 353,
    OmiseUpdateCard: 354,
    OmiseRemoveCard: 355,
    EditTransactionPaymentDate: 356,
    EditTransactionDate: 357,
    EditWhtTransactionItem: 358,
    DeleteMerchant: 359,
    DraftDailyJournal: 360,
    DownloadAccountantManualPdf: 361,
    SendApproveJournal: 362,
    EditClassification: 363,
  },
  DailyJournalType: {
    PurchaseJournal: 1,
    SalesJournal: 2,
    PaymentJournal: 3,
    ReceiveJournal: 4,
    GeneralJournal: 5,
  },
  AddressSource: {
    NA: 0,
    RD: 1,
    Corporate: 2,
    SmeLink: 3,
  },
  AddressType: {
    NoAddress: 0,
    Building: 1,
    HomeGroup: 2,
    Other: 3,
  },
  MerchantType: {
    None: 0,
    LimitedLiabilityPartnership: 1,
    CompanyLimited: 2,
    PublicCompanyLimited: 3,
    Shop: 4,
    OrdinaryPerson: 5,
    BodyOfPersons: 6, //คณะบุคคล
    Others: 7,
    OrdinaryPartnership: 8, //ห้างหุ้นส่วนสามัญ
    Foundation: 9, //มูลนิธิ
    Association: 10, //สมาคม
    JointVenture: 11,
  },
  UploadTableViewStatusType: {
    All: 0,
    AwaitIssuedTransaction: 1,
    IssuedTransaction: 2,
    Voided: 3,
  },
  UploadFileType: {
    None: 0,
    Quotation: 1,
    Invoice: 2,
    Receipt: 3,
    TaxInvoice: 4,
    CreditNote: 5,
    BillingNote: 6,
  },
  UserRight: {
    None: 0,
    ViewOnly: 1,
    RevenueExpenseDraftOnly: 2,
    RevenueExpenseApproveOnly: 3,
    RevenueAll: 4,
    ExpenseAll: 5,
    QuotationOnly: 6,
    Standard: 7,
    BasicAndAdmin: 8,
    CreateRevenueOnly: 9,
    CreateExpenseOnly: 10,
    PurchaseOrderOnly: 11,
    RevenueDraftOnly: 12,
    ExpenseDraftOnly: 13,
    RevenueApproveOnly: 14,
    ExpenseApproveOnly: 15,
    QuotationDraftOnly: 16,
    QuotationApproveOnly: 17,
    PurchaseOrderDraftOnly: 18,
    PurchaseOrderApproveOnly: 19,
    ExpenseExceptPOAll: 20,
    RevenueExceptQOAll: 21,
    RevenueExpenseExceptQOandPOApproveOnly: 22,
  },
  FinanceAndAccountRights: {
    None: 0,
    All: 1,
    FinanceAccessOnly: 2,
    GLAndStatementOnly: 3,
    DailyJournalsAll: 4,
    DailyJournalsDraftOnly: 5,
    DailyJournalsApproveOnly: 6,
    DailyJournalsAllAndFinance: 7,
    DailyJournalsDraftOnlyAndFinance: 8,
    DailyJournalsApproveOnlyAndFinance: 9,
    DailyJournalsAllAndGL: 10,
    DailyJournalsDraftOnlyAndGL: 11,
    DailyJournalsApproveOnlyAndGL: 12,
    FinanceAccountAndDailyJournalsDraftOnly: 13,
    FinanceAccountAndDailyJournalsApproveOnly: 14,
    FinanceAndGL: 15,
  },
  UploadDocumentStatusType: {
    None: 0,
    Scaned: 1,
    IsIssuedTransaction: 2,
  },
  TaxIncomeType: {
    None: 0,
    TaxIncomeType40_1_1: 1,
    TaxIncomeType40_1_2: 2,
    TaxIncomeType40_12: 3,
    TaxIncomeType40_2: 4,
    TaxIncomeType40_3: 5,
    TaxIncomeType40_4_A: 6,
    TaxIncomeType40_4_B: 7,
    TaxIncomeType40_4_C: 8,
    TaxIncomeType40_4_D: 9,
    TaxIncomeType40_4_E: 10,
    TaxIncomeType40_4_F: 11,
    TaxIncomeType40_4_G: 12,
    TaxIncomeType40_5: 13,
    TaxIncomeType40_6: 14,
    TaxIncomeType40_7: 15,
    TaxIncomeType40_8_1: 16,
    TaxIncomeType40_8_2: 17,
    TaxIncomeType40_8_3: 18,
    TaxIncomeType40_8_4: 19,
    TaxIncomeType40_8_5: 20,
    TaxIncomeType40_8_6: 21,
    TaxIncomeType40_8_7: 22,
    TaxIncomeType40_8_8: 23,
  },
  TypeOfPerson: {
    OrdinaryPerson: 1,
    JuristicPerson: 2,
  },
  PrefixNameType: {
    None: 0,
    Khun: 1,
    Mr: 2,
    Mrs: 3,
    Ms: 4,
    Other: 5,
  },
  SocialType: {
    None: 0,
    Facebook: 1,
    Line: 2,
    Whatsapp: 3,
    Wechat: 4,
    TeleGram: 5,
  },
  DepartmentType: {
    None: 0,
    GeneralManagement: 1,
    GeneralAdministration: 2,
    Sales: 3,
    Marketing: 4,
    Accounting: 5,
    Finance: 6,
    HumanResource: 7,
    Production: 8,
    Operation: 9,
    InformationTechnology: 10,
    Purchasing: 11,
    ResearchAndDevelopment: 12,
    Other: 13,
  },
  ReceivedTaxInvoiceType: {
    Old: 1,
    New: 2,
  },
  SameProductVatType: {
    Different: 0,
    SameVatExempted: 1,
    SameZeroVat: 2,
    SameSevenVat: 3,
  },
  ParamsReloadType: {
    Reload: 1,
    IsMain: 2,
  },
  ModalRemoveFileType: {
    Transaction: 1,
    Contact: 2,
    Journal: 3,
    DBDEFiling: 4,
  },
  CommentDetailType: {
    Transaction: 1,
    Contact: 2,
    Journal: 3,
    DBDEFiling: 4,
  },
  TransactionTypeForDashboardContact: {
    None: 0,
    Quotation: 1,
    Invoice: 2,
    Receipt: 3,
    TaxInvoice: 4,
    CreditNote: 5,
    BillingNote: 6,
    PurchaseOrder: 7,
    PurchaseInventoryRecord: 8,
    ExpenseRecord: 9,
    PurchaseAsset: 10,
    PurchaseTaxInvoice: 11,
    DebitNote: 12,
    CombinedPaymentNote: 13,
  },
  TaxInvoiceTableViewStatusType: {
    All: 0,
    Draft: 1,
    AwaitApproval: 2,
    IssuedTaxInvoice: 3,
    AwaitReceiveTaxInvoice: 4,
    ReceivedTaxInvoice: 5,
    EtaxInvoice: 6,
    Voided: 7,
  },
  TaxInvoiceTableView: {
    None: 0,
    Id: 1,
    Number: 2,
    Date: 3,
    NetAmount: 4,
    VatTotal: 5,
  },
  TaxInvoiceStatus: {
    None: 0,
    Voided: 1,
    Draft: 2,
    AwaitApproval: 3,
    Approved: 4,
  },
  DocumentDateType: {
    None: 0,
    IssuedDate: 1,
    DueDate: 2,
    PaidDate: 3,
    AcceptedDate: 4,
  },
  DocumentHistoryDateType: {
    None: 0,
    CreatedDate: 1,
    ApprovedDate: 2,
    VoidedDate: 3,
  },
  QuotationStatus: {
    None: 0,
    Voided: 1,
    Draft: 2,
    AwaitApproval: 3,
    AwaitResponse: 4,
    Expired: 5,
    ApprovedOrAccepted: 6,
    CreatedTransaction: 7,
  },
  QuotationTableViewStatusType: {
    All: 0,
    Draft: 1,
    AwaitApproval: 2,
    Outstanding: 3,
    Expired: 4,
    Accepted: 5,
    Approved: 6,
    Voided: 7,
    Success: 8,
  },
  QuotationTableView: {
    None: 0,
    Id: 1,
    Number: 2,
    Date: 3,
    DueDate: 4,
    NetAmount: 5,
    ActionDate: 6,
  },
  InvoiceTableViewStatusType: {
    All: 0,
    Draft: 1,
    AwaitApproval: 2,
    WaitingPayment: 3,
    Overdue: 4,
    Paid: 5,
    AwaitReceipt: 6,
    GotReceipt: 7,
    Voided: 8,
    Recurring: 9,
  },
  InvoiceTableView: {
    None: 0,
    Id: 1,
    Number: 2,
    Date: 3,
    DueDate: 4,
    NetAmount: 5,
  },
  InvoiceStatus: {
    None: 0,
    Voided: 1,
    Draft: 2,
    AwaitApproval: 3,
    Outstanding: 4,
    Overdue: 5,
    PaidOrAwaitReceipt: 6,
    GotReceipt: 7,
  },
  ReceiptTableViewStatusType: {
    All: 0,
    Draft: 1,
    AwaitApproval: 2,
    Approved: 3,
    Voided: 4,
    Recurring: 5,
  },
  ReceiptTableView: {
    None: 0,
    Id: 1,
    Number: 2,
    Date: 3,
    NetAmount: 4,
  },
  ReceiptStatus: {
    None: 0,
    Voided: 1,
    Draft: 2,
    AwaitApproval: 3,
    Approved: 4,
  },
  Package: {
    Trial: 0,
    Free: 1,
    Basic: 2,
    Pro: 3,
    ProPlus: 4,
    AFPFree: 5,
    AFPLedger: 6,
    AFPAccountant: 7,
  },
  FavoriteType: {
    None: 0,
    Quotation: 1,
    Invoice: 2,
    Receipt: 3,
    TaxInvoice: 4,
    CreditNote: 5,
    BillingNote: 6,
    PurchaseOrder: 7,
    PurchaseInventoryRecord: 8,
    ExpenseRecord: 9,
    PurchaseAsset: 10,
    PurchaseTaxInvoice: 11,
    ReceiveCreditNote: 12,
    CombinedPaymentNote: 13,
  },
  PeriodType: {
    DayOfMonth: 1,
    DateOfMonth: 2,
    EverDay: 3,
    EveryWeek: 4,
    EveryYear: 5,
  },
  DayType: {
    Sunday: 0,
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
  },
  MonthType: {
    January: 1,
    February: 2,
    March: 3,
    April: 4,
    May: 5,
    June: 6,
    July: 7,
    August: 8,
    September: 9,
    October: 10,
    November: 11,
    December: 12,
  },
  UntilType: {
    Forever: 1,
    Date: 2,
    XTime: 3,
  },
  RecurringStatus: {
    Active: 0,
    End: 1,
    Failed: 2,
  },
  RecurringTableView: {
    None: 0,
    Id: 1,
    Number: 2,
    ContactName: 3,
    NetAmount: 4,
    RecurringNextTime: 5,
    CreatedTransactionAsStatus: 6,
  },
  FinanceDetailTableViewStatusType: {
    None: 0,
    AccountingRecord: 1,
    Statement: 2,
    ExpenseClaim: 3,
  },
  ChequeTableViewStatusType: {
    None: 0,
    ChequeReceive: 1,
    ChequeIssue: 2,
  },
  WhtTableViewStatusType: {
    All: 0,
    Voided: 1,
  },
  ReceivedWht: {
    None: 0,
    ReceivedWht: 1,
    NotReceivedWht: 2,
  },
  WhtTableView: {
    id: 0,
    number: 1,
    contactFullName: 2,
    date: 3,
    transactionNumber: 4,
    subTotalForCalculateWht: 5,
    transactionNetAmount: 6,
  },
  FinancePaymentType: {
    None: 0,
    Receivied: 1,
    Paid: 2,
    Deposit: 3,
    Withdrawal: 4,
    CashCheque: 5,
    ClearCheque: 6,
    TransferIn: 7,
    TransferOut: 8,
    Record: 9,
    TransferPayment: 10,
    BankWithdrawal: 11,
  },
  HistoryStatusType: {
    Created: 1,
    Approved: 2,
    Opened: 3,
    Accepted: 4,
    SendEmail: 5,
    Printed: 6,
    Edited: 7,
    Paided: 8,
    Deleted: 9,
    SendETax: 10,
    ReRecordJournal: 11,
    RejectTransaction: 12,
  },
  AllocationDocumentFinanceType: {
    All: 0,
    Income: 1,
    Expense: 2,
  },
  AllocationValueType: {
    Amount: 0,
    Percent: 1,
  },
  ReceiptReferenceType: {
    None: 0,
    Quotation: 1,
    Invoice: 2,
    BillingNote: 6,
    PP30: 8,
  },
  ChequeStatus: {
    OutStanding: 1,
    Waiting: 2,
  },
  HeaderTransactionType: {
    None: 0,
    Quotation: 1,
    Invoice: 2,
    Receipt: 3,
    TaxInvoice: 4,
    CreditNote: 5,
    BillingNote: 6,
    DeliveryNote: 7,
    PurchaseRequisition: 8,
    TemporaryDeliveryNote: 9,
    FixAssetExpense: 10,
    InvoiceSalesTaxReceipt: 11,
    ReceiptSalesTaxReceipt: 12,
    CreditNoteTaxReceipt: 13,
    DebitNote: 39,
    DebitNoteTaxInvoice: 40,
    PurchaseOrderAsset: 50,
  },
  YearType: {
    Thai: 0,
    Eng: 1,
  },
  DropdownSettingYearType: {
    Year_4_Eng: 0,
    Year_4_Thai: 1,
    Year_2_Eng: 2,
    Year_2_Thai: 3,
    Not_Show: 4,
  },
  ChequeFeeDeductType: {
    None: 0,
    DeductFromAmountToPay: 1,
    AddToAmountToPay: 2,
  },
  DueDateSettingType: {
    None: 0,
    DateDistanct: 1,
    DateDistanctNextMonth: 2,
    EndOfMonth: 3,
    EndOfMonthFromNextMonth: 4,
  },
  BankAccountPageType: {
    AccountingRecordPage: 0,
    BankStatementRecordPage: 1,
  },
  DueDateSettingType: {
    None: 0,
    DateDistanct: 1,
    DateDistanctNextMonth: 2,
    EndOfMonth: 3,
    EndOfMonthFromNextMonth: 4,
  },
  DashBoardChartPieType: {
    IncomeProduct: 1,
    ExpenseProduct: 2,
    IncomeContact: 3,
    ExpenseContact: 4,
    IncomeAccount: 5,
    ExpenseAccount: 6,
    WhereMoney: 7,
    ContactIncomeDashboard: 8,
    ContactExpenseDashboard: 9,
    ProductDetailChartBySell: 10,
    ProductDetailChartByPurchase: 11,
  },
  TransferFeeDeductType: {
    None: 0,
    WithDrawalAccount: 1,
    DepositeAccount: 2,
  },
  PaymentChartOfAccount: {
    BankFee: 174,
  },
  CreditNoteTableViewStatusType: {
    All: 0,
    Draft: 1,
    AwaitApprove: 2,
    Approved: 3,
    Paid: 4,
    Voided: 5,
  },
  CreditNoteTableView: {
    None: 0,
    Id: 1,
    Number: 2,
    Date: 3,
    NetAmount: 4,
  },
  DebitNoteTableViewStatusType: {
    All: 0,
    Draft: 1,
    AwaitApprove: 2,
    Approved: 3,
    Paid: 4,
    Voided: 5,
  },
  DebitNoteTableView: {
    None: 0,
    Id: 1,
    Number: 2,
    Date: 3,
    DueDate: 4,
    NetAmount: 5,
  },
  EmailReportType: {
    Weekly: 1,
    Monthly: 2,
  },
  UserOrderBy: {
    Id: 1,
    DisplayName: 2,
    LastestLogin: 3,
  },
  InvitationType: {
    InviteUser: 0,
    InviteUserToMerchant: 1,
    InviteTypeTwo: 2,
    InviteTypeThree: 3,
    InviteTypeFour: 4,
  },
  UserRightSetting: {
    ViewOnly: 1,
    Partial: 2,
    Basic: 3,
    Admin: 4,
  },
  PartialRightType: {
    RevenueExpenseDraftOnly: 1,
    RevenueExpenseApproveOnly: 2,
    RevenueAll: 3,
    ExpenseAll: 4,
    QuotationOnly: 5,
    CreateRevenueOnly: 6,
    CreateExpenseOnly: 7,
    PurchaseOrderOnly: 8,
    RevenueDraftOnly: 9,
    ExpenseDraftOnly: 10,
    RevenueApproveOnly: 11,
    ExpenseApproveOnly: 12,
    QuotationDraftOnly: 13,
    QuotationApproveOnly: 14,
    PurchaseOrderDraftOnly: 15,
    PurchaseOrderApproveOnly: 16,
    ExpenseExceptPOAll: 17,
    RevenueExceptQOAll: 18,
    RevenueExpenseExceptQOandPOApproveOnly: 19,
  },
  BasicRightType: {
    CanViewExport: 1,
    ConNotViewExport: 2,
  },
  ViewRightType: {
    CanViewExport: 1,
    ConNotViewExport: 2,
  },
  ViewExportType: {
    CanViewExport: 1,
    ConNotViewExport: 0,
  },
  PartialRightReportType: {
    CanViewExport: 1,
    ConNotViewExport: 2,
  },
  DailyJournalsRightType: {
    None: 0,
    DraftOnly: 1,
    ApproveOnly: 2,
    All: 3,
  },
  ApiPartner: {
    None: 0,
    KetshopWeb: 1,
    ZORT: 2,
    Wisible: 3,
    xCommerce: 4,
    Gofive: 5,
    BoxMe: 6,
    Leceipt: 7,
    UCommerce: 8,
    HumanSoft: 9,
    Shipnity: 10,
  },
  ApiPartnerDetail: {
    None: 0,
    KetshopWeb: 1,
    ZORT: 2,
    Wisible: 3,
    xCommerce: 4,
    Empeo: 5,
    Venio: 6,
    BoxMe: 7,
    Page365: 8,
    BentoWeb: 9,
    UCommerce: 10,
    LineMyShop: 11,
    Shopee: 12,
    Lazada: 13,
    Lightwork: 14,
    HumanSoft: 15,
    Shipnity: 16,
  },
  AuthorityRole: {
    None: 0,
    ViewOnly: 1,
    PartialRights: 2,
    StandardRights: 3,
    Admin: 4,
  },
  IconAllocationItem: {
    GraphBar1: 1,
    Pin1: 2,
    Star1: 3,
    GraphBar2: 4,
    Percentage: 5,
    Wallet: 6,
    Document: 7,
    Building: 8,
    Suitcase: 9,
    Location: 10,
    Plane: 11,
    PieChart: 12,
    MultiUsers: 13,
    Shopping: 14,
    Merchant: 15,
    Box: 16,
    MailBox: 17,
    Receipt: 18,
    Approve: 19,
    Windmill: 20,
    Lock: 21,
    Study: 22,
    Folder: 23,
    PaperPlane: 24,
    Goal: 25,
    ArrowRight: 26,
    Book: 27,
    Wrench: 28,
    Destination: 29,
    Coin: 30,
    Car: 31,
    Note: 32,
    Gift: 33,
    Education: 34,
    Handshake: 35,
    Health: 36,
    Home: 37,
    Idea: 38,
    Annouce: 39,
    Meeting: 40,
    Pint2: 41,
    TreeChart: 42,
    Brush: 43,
    Piggy: 44,
    Achrive: 45,
    Calculator: 46,
    Subway: 47,
    Label: 48,
    Shopee: 49,
    Lazada: 50,
    Facebook: 51,
    Line: 52,
    Internet: 53,
    Laptop: 54,
  },
  NotificationMessageType: {
    None: 0,
    Quotation: 1,
    PurcahseOrder: 2,
    Invoice: 3,
    InvoiceAllProduct: 4,
    Expense: 5,
    ExpenseAllProduct: 6,
    PurchaseAsset: 7,
    PurchaseAssetAllProduct: 8,
    Receipt: 9,
    StockActivityStockCardMovement: 10,
    TaxInvoice: 11,
    TaxInvoiceInRevenueDepartmentFormat: 12,
    TrialBalanceWithSubAccount: 13,
    TrialBalance: 14,
    PurcahseTaxInvoice: 15,
    PurchaseTaxInvoiceInRevenueDepartFormat: 16,
    Journal: 17,
    BillingNoteInvoice: 18,
    BillingNoteInvoiceAllInvoice: 19,
    BillingNoteExpense: 20,
    BillingNoteExpenseAllExpense: 21,
    Finance: 22,
    PP30InputVat: 23,
    PP30OutputVat: 24,
    CreditNote: 25,
    CreditNoteExpense: 26,
    AssetTemplateGroup: 27,
    AssetTemplate: 28,
    WithHeldTax: 29,
    WithHoldingTax: 30,
    GeneralLedgerTransaction: 31,
    AllGeneralLedger: 32,
    AllGeneralLedgerWithSubAccount: 33,
    AgingReportAR: 34,
    AgingReportAP: 35,
    Product: 36,
    ProfitLoss: 37,
    ChartOfAccount: 38,
    BalanceSheet: 39,
    Unit: 40,
    ReportDocument: 41,
    Asset: 42,
    StatementEFiling: 43,
    AllReport: 44,
    Contact: 45,
    PurchaseTaxInvoiceNotUse: 46,
    SalesTaxInvoiceNotUse: 47,
    PP30TaxFilingTextFile: 48,
    WithHoldingTaxPND2: 49,
    WithHoldingTaxPND3: 50,
    WithHoldingTaxPND53: 51,
    CashflowStatementReport: 52,
    AllReportSalesByCustomerReport: 53,
    AllReportSalesByAccountReport: 54,
    AllReport_RemainingFinanceBalanceReport: 55,
    StatementEFilingExcel: 56,
    AllReportProductSalesByContact: 57,
    AllReport_ProductServiceSalesSummaryReportOnDailyAccount: 58,
    Pnd53TaxFilingTextFile: 59,
    Pnd3TaxFilingTextFile: 60,
    DailyJournal: 61,
    DocumentQuotation: 62,
    DocumentInvoice: 63,
    DocumentReceipt: 64,
    DocumentTaxInvoice: 65,
    DocumentPurchaseOrder: 66,
    DocumentExpense: 67,
    DocumentBillingNote: 68,
    DocumentBillingNoteExpense: 69,
    DocumentCreditNote: 70,
    DocumentCreditNoteExpense: 71,
    DocumentPurchaseTaxInvoice: 72,
    DocumentWithholdingTax: 73,
    ImportTransactionPurchaseInventory: 74,
    ImportTransactionExpense: 75,
    ImportTransactionInvoice: 76,
    ImportTransactionReceipt: 77,
    ImportTransactionQuotation: 78,
    ImportTransactionPurchaseOrder: 79,
    Statement: 80,
    AllReportWithHoldingTaxPND2: 81,
    AllReportWithHoldingTaxPND3: 82,
    AllReportWithHoldingTaxPND53: 83,
    ChequeReport: 84,
    WorkingPaper: 85,
    RecalCostOfGoodSoldByMerchantCalculated: 86,
    RecalCostOfGoodSoldByProductCalculated: 87,
    RecalCostOfGoodSoldFailed: 88,
    DebitNote: 89,
    DocumentDebitNote: 90,
    DebitNoteExpense: 91,
    DocumentDebitNoteExpense: 92,
    VoidImportTransactionFailed: 93,
    TrialBalanceSeperateMonth: 94,
    VoidImportTransactionSuccess: 95,
    ImportTransactionReceiptFromInvoice: 96,
    ImportTransactionJournal: 97,
    DepreciateAssetMonthly: 98,
    TaxPnd: 99,
    TaxPP30SaleTax: 100,
    TaxPP30PurchaseTax: 101,
    TaxFetchPP30Transaction: 102,
    TaxFetchWhtCertificate: 103,
    AllReportPurchaseTaxInvoiceNotUseFromPeakTax: 104,
    AllReportSalesTaxInvoiceNotUseFromPeakTax: 105,
    AllReportTaxInvoiceFromPeakTax: 106,
    AllReportPurchaseTaxInvoiceFromPeakTax: 107,
    AllReportPurchaseTaxInvoiceNotUseFromOldPeak: 108,
    AllReportSalesTaxInvoiceNotUseFromOldPeak: 109,
    AllReportTaxInvoiceFromOldPeak: 110,
    AllReportPurchaseTaxInvoiceFromOldPeak: 111,
    FinanceBankStatement: 112,
    ExecutiveSummary: 113,
    StatementOfCashflow: 114,
    RecieveBenefit: 115,
    CamPaignBeforeExpire: 116,
    BeforeExpireByDate: 117,
    QuotaExpire: 118,
  },
  CreditLimitType: {
    Default: 0,
    Unlimit: 1,
    Custom: 2,
  },
  ProductTableOrder: {
    None: 0,
    Id: 1,
    Code: 2,
    Name: 3,
    RemainStock: 4,
    SellPrice: 5,
  },
  StockType: {
    None: 0,
    FIFO: 1,
    Average: 2,
  },
  BranchCompanyType: {
    None: 0,
    Quarter: 1,
    Branch: 2,
  },
  ContactContryType: {
    None: 0,
    Thai: 1,
    Others: 2,
  },
  VerifiedStatus: {
    None: 0,
    Proccessing: 1,
    Success: 2,
  },
  ProductDetailTapType: {
    Detail: 0,
    Summary: 1,
    Stock: 2,
  },
  JournalCreateStatus: {
    AwaitRecord: -3,
    Draft: -2,
    AwaitApproval: -1,
    Approve: 0,
  },
  JournalRefType: {
    None: 0,
    Quotation: 1,
    Invoice: 2,
    Receipt: 3,
    TaxInvoice: 4,
    PurchaseOrder: 5,
    Expense: 6,
    ExpenseTaxInvoice: 7,
    Contact: 8,
    AdjustProductTemplateAmountStockActivityId: 9,
    BankAccount: 10,
    Cheque: 11,
    PaymentInvoice: 12,
    PaymentExpense: 13,
    CreditNote: 14,
    BillingNoteInvoice: 15,
    PP30: 16,
    BillingNoteExpense: 17,
    CreditNoteExpense: 18,
    FixAssetDepreciation: 19,
    Asset: 20,
    ProductTemplateCarringBalance: 21,
    TransferPayment: 22,
    Pnd53: 23,
    Pnd3: 24,
    ReceivedTaxInvoiceExpense: 25,
    ReceivedTaxInvoiceCreditNote: 26,
    DebitNote: 27,
    DebitNoteExpense: 28,
    FixAssetStopDepreciation: 29,
    TaxPP30: 30,
    TaxPND3: 31,
    TaxPND53: 32,
    ReceivedTaxInvoiceDebitNote: 33,
    PaymentCreditNote: 34,
    PaymentCreditNoteExpense: 35,
    PaymentDebitNote: 36,
    PaymentDebitNoteExpense: 37,
  },
  ValidationStatus: {
    Urgent: -2,
    Warning: -1,
    None: 0,
  },
  TrialBalancePeriodType: {
    ThisMonth: 1,
    LastMonth: 2,
    ThisYear: 3,
    Lastyear: 4,
    Custom: 5,
  },
  DailyJournalPeriodType: {
    ThisMonth: 1,
    LastMonth: 2,
    ThisYear: 3,
    Lastyear: 4,
    Custom: 5,
  },
  TrialBalanceDisplayType: {
    BeforeCloseIncomeAndExpenses: 1,
    AfterCloseIncomeAndExpenses: 2,
    MonthlyReport: 3,
    SummarizeMonthlyReport: 4,
  },
  CotentTableTrialBalanceType: {
    BeginningBalance: 1,
    Change: 2,
    EndingBalance: 3,
    Monthly: 4,
  },
  AdvancedSearchAllocationSelectType: {
    NoClassification: -2,
  },
  AdvancedSearchAllocationItemSelectType: {
    SelectAllItems: -1,
    NotSpecified: -2,
  },
  EtaxConnectType: {
    None: 0,
    GoogleGmail: 1,
    INet: 2,
  },
  OnlineViewType: {
    DocumentOnlineView: 0,
    OldOnlineView: 1,
  },
  PriceChangeType: {
    Purchase: 0,
    Sale: 1,
  },
  PriceChangePeriodTpye: {
    None: 0,
    TenTimes: 1,
    TwentyTimes: 2,
    Monthly: 3,
  },
  LotMovementType: {
    NewLotBeginningBalance: -4,
    NewLotAdjustIncrease: -3,
    NewLotCreditNoteSaleNoReference: -2,
    NewLotDebitNoteExpenseNoReference: -1,
    NewLotPurchase: 0,
    Sale: 1,
    SaleAdjustDecrease: 2,
    LotCreditNoteExpenseReturnStock: 3,
    ReturnCostWhenCreditNoteExpenseReturnStock: 4,
    AdjustLotWhenCreditNoteExpenseReturnStock: 5,
    AdjustCostWhenCreditNoteExpenseReturnStock: 6,
    LotDebitNoteExpenseIncreaseStock: 7,
    AdjustCostWhenDebitNoteExpense: 8,
    LotDebitNoteExpenseIncreaseCostOnly: 9,
    AdjustCostWhenDebitNoteExpenseIncreaseCostOnly: 10,
    AdjustCostWhenCreditNoteExpenseDecreaseCostOnly: 11,
    CreditNoteExpenseDecreaseCostOnly: 12,
    ReturnCostWhenCreditNoteReturnStock: 13,
    SaleWhenCreditNoteExpenseReturnStock: 14,
    SaleWhenCreditNoteExpeseNoReference: 15,
    SaleWhenCreditNoteReturnStock: 16,
    OrderSale: 17,
    OrderSaleAdjustDecrease: 18,
    OrderSaleWhenCreditNoteExpenseReturnStock: 19,
    OrderSaleWhenCreditNoteExpeseNoReference: 20,
    OrderSaleWhenCreditNoteReturnStock: 21,
    SaleBeforePurchase: 22,
    SaleBeforePurchaseAdjustDecrease: 23,
    SaleBeforePurchaseWhenCreditNoteExpenseReturnStock: 24,
    SaleBeforePurchaseWhenCreditNoteExpeseNoReference: 25,
    SaleBeforePurchaseWhenCreditNoteReturnStock: 26,
    AdjustWhenCreditNoteExpeseNoReference: 27,
    AdjustBeforePurchaseWhenCreditNoteExpeseNoReference: 28,
  },
  StockMovementTableType: {
    None: 0,
    Purchase: 1,
    Sale: 2,
    DebitNoteExpense: 3,
    CreditNoteExpense: 4,
    DebitNote: 5,
    CreditNote: 6,
    Withdraw: 7,
    Damage: 8,
    TransferIn: 9,
    TransferOut: 10,
    Adjust: 11,
    BeginingBalance: 12,
  },
  SecondaryAccountType: {
    CashEquivalent: 1,
    ShortTermInvestment: 2,
    ReceivablesAndOtherReceivables: 3,
    Inventory: 4,
    OtherCurrentAssets: 5,
    LongTermInvestments: 6,
    LongTermLendings: 7,
    PropetyInvestments: 8,
    PropertyPlantsAndEquipments: 9,
    IntengibleAssets: 10,
    OtherNonCurrentAssets: 11,
    BankOverDraftAndShortTermLoans: 12,
    AccountPayablesAndOtherPayables: 13,
    CurrentPortionOfLongTermLoans: 14,
    EstimatedShortTermLiability: 15,
    TaxAndSocialSecurityLiabilities: 16,
    OtherCurrentLiabilities: 17,
    LongTermLoans: 18,
    EstimatedLongTermLiability: 19,
    OtherNonCurrentLiability: 20,
    Capital: 21,
    Reserves: 22,
    RetainedEarnings: 23,
    Revenues: 24,
    OtherRevenues: 25,
    CostsOfSales: 26,
    SalesAndMarketingExpenses: 27,
    GeneralAndAdministrativeExpenses: 28,
    OtherExpenses: 29,
    FinanceCosts: 30,
    IncomeTax: 31,
    OtherComponentsOfShareholdersEquity: 32,
  },
  ETaxResponseErrorType: {
    DocumentNotFound: 1,
    DocumentIsNotTaxInvoice: 2,
    DocumentNumberMissingOrInvalidLength: 3,
    MerchantSellerPhoneNumberInvalidLength: 4,
    ContactBuyerPhoneNumberInvalidLength: 5,
    MerchantSellerEmailInvalidLength: 6,
    ContactBuyerEmailInvalidLength: 7,
    MerchantSellerInvalidData: 8,
    MerchantSellerPostCodeMissingOrInvalid: 9,
    MerchantSellerCountryCodeInvalid: 10,
    MerchantSellerAddressCodeInvalid: 11,
    ContactBuyerInvalidData: 12,
    ContactBuyerPostCodeMissingOrInvalid: 13,
    ContactBuyerCountryCodeInvalid: 14,
    ContactBuyerAddressCodeInvalid: 15,
    DocumentItemBillingNote: 16,
    DocumentItemAsset: 17,
    DocumentItem: 18,
    ContactTaxNumberInvalidData: 19,
    MerchantTaxNumberInvalidData: 20,
    DocumentItemDescriptionInvalidLength: 21,
    ContactBuyerPhoneNumberInvalidFormat: 22,
    MerchantSellerPhoneNumberInvalidFormat: 23,
    ReferenceNotFound: 24,
    InvalidDocumentType: 25,
    InvalidPurpose: 26,
    DocumentItemInvalidAmount: 27,
  },
  OrganizationBusinessType: {
    Unknown: 0,
    ServiceBusinessB2C: 1,
    ServiceBusinessB2B: 2,
    MerchandisingBusinessB2C: 3,
    MerchandisingBusinessB2B: 4,
    ManufacturingBusiness: 5,
  },
  BusinessCategory: {
    NoAnswer: 0,
    AccountingFirmOrFreelanceAccountant: 1,
    ECommerceSeller: 2,
    B2BTrading: 3,
    B2CTrading: 4,
    B2BService: 5,
    B2CService: 6,
    Manufacturing: 7,
    OtherType: 8,
    RetailAndTrade: 9,
    Services: 10,
    RealEstateServices: 11,
  },
  OrganizationSize: {
    NoAnswer: 0,
    OneToFive: 1,
    SixToTen: 2,
    ElevenToThirty: 3,
    ThirtyOneToFifty: 4,
    MoreThanFiftyOne: 5,
    OnlyProprietor: 6,
    ElevenToFifty: 7,
    FiftyOneToOneHundred: 8,
    MoreThanOneHundred: 9,
  },
  AmountofAccountantBusiness: {
    Unknown: 0,
    OnlyOwnersAndPartners: 1,
    More1to5Persons: 2,
    More6to10Persons: 3,
    More11to20Persons: 4,
    More21to50Persons: 5,
    More51to100Persons: 6,
    Morethan100Persons: 7,
  },
  AmountofCustomerBusiness: {
    More1to10Customers: 1,
    More11to20Customers: 2,
    More21to50Customers: 3,
    More51to100Customers: 4,
    Morethan100Customers: 5,
  },
  AnnualIncomeBusiness: {
    Unknown: 0,
    Lessthan2millionBaht: 1,
    More2to5millionBaht: 2,
    More5to20millionBaht: 3,
    More20to50millionBaht: 4,
    More50to100millionBaht: 5,
    Morethan100millionBaht: 6,
  },
  IsPartner: {
    No: 0,
    Yes: 1,
  },
  IsAccountingFirm: {
    No: 0,
    Yes: 1,
  },
  UsePeakFor: {
    CreateDocument: 1,
    RecordingData: 2,
    AccountRecord: 3,
    UsingForCreating: 4,
    UsingForControl: 5,
    UsingForSalary: 6,
    UsingForConnecting: 7,
  },
  ViewOnboardingPage: {
    ViewIntroductVideoPage: 1,
    ViewOnboardingFirstPage: 2,
    ViewOnlineViewPage: 3,
    ViewLinePeakPage: 4,
    ViewPeakBoardPage: 5,
    ViewPeakPayrollPage: 6,
    ViewPeakTaxPage: 7,
    ViewPeakSupportPage: 8,
  },
  PackageMonth: {
    OneMonth: 1,
    ThreeMonth: 3,
    TwelveMonth: 12,
  },
  SubscriptionHistoryTableView: {
    None: 0,
    User: 1,
    Date: 2,
    Status: 3,
  },
  PaymentGatewayType: {
    None: 0,
    SCB: 1,
    Omise: 2,
    SCBQR: 3,
    Swap: 4,
    Transfer: 5,
  },
  paymentStatus: {
    Processing: 0,
    Success: 1,
  },
  isCancelled: {
    Success: 0,
    NoSuccess: 1,
  },
  PackageErrorCode: {
    PromoCodeError: 0,
    PromoCodeUsed: 1,
    PromoCodeExpired: 2,
    PromoCodeInvalidMerchantChecked: 3,
    PromoCodeInvalidUserChecked: 4,
    PromoCodeUnpaidMerchantChecked: 5,
    PromoCodeUserEmailChecked: 6,
    InvalidUpgradeToPackage: 7,
    InvalidExpireDateTime: 8,
    InvalidPaymentAmount: 9,
    InvalidDiscountAmount: 10,
    InvalidWhtAmount: 11,
    InvalidValidatedAmount: 12,
    OmiseChargedFail: 13,
    ScbQrPaymentUnpaid: 14,
    PromoCodeNotFound: 15,
    InvalidPackageType: 16,
    InvalidPackagePeriod: 17,
    PromoCodeStarted: 18,
    PromoCodeFixUser: 19,
    PromoCodeFixMerchant: 20,
    PromoCodeFixClient: 21,
    PromoCodeFixFirm: 22,
    PromoCodeRegisterType: 23,
    PromoCodeCampaignNotFound: 24,
    ScbQrPaymentBillingCompleted: 25,
    MerchantPackageInvalid: 26,
    PackagePeriodInvalid: 27,
  },
  WhtPackageType: {
    None: 0,
    TwoPercent: 2,
    ThreePercent: 3,
  },
  PackagePeriodType: {
    Month: 1,
    Day: 2,
    ExpiredDate: 3,
  },
  PromoCampaign: {
    Discount: 1,
    Package: 2,
    Extra: 3,
  },
  SubscriptionTableDetailActionType: {
    None: 0,
    ExtendPackage: 1,
    UpgradePackage: 2,
    UsePromoCode: 3,
    SwapPackage: 4,
    TranferOut: 5,
    TranferIn: 6,
  },
  ChangeJournalDescription: {
    None: 0,
    NotChange: 1,
    Change: 2,
  },
  AccountScrapValType: {
    None: 0,
    OneBath: 1,
    TenPercent: 2,
    Custom: 3,
  },
  AccountScrapType: {
    Amount: 0,
    Percent: 1,
  },
  Position: {
    None: -1,
    Other: 0,
    BusinessOwner: 1,
    Bookkeeper: 2,
    Salesperson: 3,
    Admin: 4,
    Accountant: 5,
    Employee: 6,
    AccountingFirm: 7,
    Student: 8,
  },
  Department: {
    None: -1,
    Other: 0,
    GeneralManagement: 1,
    GeneralAdministration: 2,
    Sales: 3,
    Marketing: 4,
    Accounting: 5,
    Finance: 6,
    HumanResource: 7,
    Production: 8,
    Operation: 9,
    InformationTechnology: 10,
    Purchasing: 11,
    ResearchAndDevelopment: 12,
    General: 13,
  },
  PndType: {
    None: 0,
    PND1: 1,
    PND2Specialkor: 2,
    PND2: 3,
    PND3: 4,
    PND2kor: 5,
    PND3kor: 6,
    PND53: 7,
    PND54: 8,
  },
  ActivityLogSource: {
    None: 0,
    PEAK_Engine: 1,
    PEAK_Experience: 2,
    PEAK_API: 3,
    TransactionImport: 4,
    ZORT: 5,
    KetShopWeb: 6,
    XCommerce: 7,
    BentoWeb: 8,
    Wisible: 9,
    Empeo: 10,
    Recurring: 11,
    BoxMe: 12,
    PeakAsset: 13,
    LineConnect: 14,
    UCommerce: 15,
    Page365: 16,
    PeakPayroll: 17,
    PeakBoard: 18,
    PeakTax: 19,
    LineMyShop: 20,
    Shopee: 21,
    Lazada: 22,
    SCBQR: 23,
    PeakAdmin: 24,
    PaySolutionPayment: 25,
    FileVault: 26,
    BayQR: 27,
  },
  IncomeStatementType: {
    Statement220000: 1,
    Statement240000: 2,
    Statement260000: 3,
  },
  IsFilingStatementFirsTime: {
    No: 0,
    Yes: 1,
  },
  IsRestatement: {
    No: 0,
    Yes: 1,
  },
  DBDEFilingTableViewStatusType: {
    All: 0,
    Draft: 1,
    AwaitApproval: 2,
    Approve: 3,
    Voided: 4,
  },
  DBDEFilingStatus: {
    Draft: -2,
    AwaitApproval: -1,
    Approve: 0,
  },
  DBDEFilingTimelineType: {
    None: 0,
    Period: 1,
    Info: 2,
    Remark: 3,
    Detail: 4,
  },
  StatementType: {
    Statement210000: 0,
    Statement220000: 1,
    Statement240000: 2,
    Statement260000: 3,
    Statement410000: 4,
  },
  Statement210000: {
    CashAndCashEquivalents: 1,
    CurrentInvestments: 2,
    TradeAndOtherReceivables: 3,
    CurrentLoansAndAdvances: 4,
    Inventories: 5,
    OtherCurrentAssets: 6,
    TotalCurrentAssets: 7,
    InvestmentsHeldAsAvailableForSale: 8,
    InvestmentsInAssociates: 9,
    InvestmentsInSubsidiaries: 10,
    InvestmentsInJointVentures: 11,
    OtherNonCurrentInvestments: 12,
    NonCurrentLoansAndAdvances: 13,
    InvestmentProperty: 14,
    NonCurrentAssetsClassifiedAsHeldForSale: 15,
    PropertyPlantAndEquipment: 16,
    IntangibleAssets: 17,
    OtherNonCurrentAssets: 18,
    TotalNonCurrentAssets: 19,
    TotalAssets: 20,
    BankOverdraftsAndShortTermBorrowingFromFinancialInstitutions: 21,
    TradeAndOtherPayables: 22,
    CurrentPortionOfLongTermLiabilities: 23,
    ShortTermBorrowings: 24,
    CurrentIncomeTaxPayable: 25,
    ShortTermProvisions: 26,
    OtherCurrentLiabilities: 27,
    TotalCurrentLiabilities: 28,
    LongTermBorrowings: 29,
    EmployeeBenefitObligation: 30,
    LongTermProvisions: 31,
    OtherNonCurrentLiabilities: 32,
    TotalNonCurrentLiabilities: 33,
    Liabilities: 34,
    PreferenceSharesNumberOfShares: 35,
    PreferenceSharesParValue: 36,
    OrdinarySharesNumberOfShares: 37,
    OrdinarySharesParValue: 38,
    PreferenceShares: 39,
    OrdinaryShares: 40,
    SharePremiumAccountPreferenceShares: 41,
    SharePremiumAccountOrdinaryShares: 42,
    LegalReserves: 43,
    Others: 44,
    Unappropriated: 45,
    OtherComponentsOfShareholdersEquity: 46,
    TotalShareholdersEquity: 47,
    TotalLiabilitiesAndShareholdersEquity: 48,
    AuthorizedPreferenceShares: 49,
    AuthorizedOrdinaryShares: 50,
  },
  Statement240000: {
    RevenuesFromSalesOrRevenuesFromServices: 1,
    InterestIncome: 2,
    ContractRevenue: 3,
    OtherIncomes: 4,
    TotalRevenue: 5,
    CostsOfSaleOfGoodsAndRenderingOfServices: 6,
    ContractCosts: 7,
    SellingExpense: 8,
    AdministrativeExpense: 9,
    OtherExpenses: 10,
    TotalExpenses: 11,
    ProfitLossBeforeFinanceCostsAndIncomeTaxExpense: 12,
    FinanceCosts: 13,
    ProfitLossBeforeIncomeTaxExpense: 14,
    IncomeTaxExpense: 15,
    NetProfitLoss: 16,
  },
  Statement260000: {
    RevenuesFromSalesOrRevenuesFromServices: 1,
    ContractRevenue: 2,
    CostsOfSaleOfGoodsAndRenderingOfServices: 3,
    ContractCosts: 4,
    GrossProfitLoss: 5,
    InterestIncome: 6,
    OtherIncomes: 7,
    ProfitLossBeforeExpenses: 8,
    SellingExpense: 9,
    AdministrativeExpense: 10,
    OtherExpenses: 11,
    TotalExpenses: 12,
    ProfitLossBeforeFinanceCostsAndIncomeTaxExpense: 13,
    FinanceCosts: 14,
    ProfitLossBeforeIncomeTaxExpense: 15,
    IncomeTaxExpense: 16,
    NetProfitLoss: 17,
  },
  Statement410000: {
    Equity: 1,
    EquityRestated: 2,
    IncreaseDecreaseInIssuedAndPaidUpShareCapitalPreferenceShares: 3,
    IncreaseDecreaseInIssuedAndPaidUpShareCapitalOrdinaryShares: 4,
    ProfitLoss: 5,
    Dividends: 6,
    ExchangeDifferenceOnTranslatingFinancialStatements: 7,
    GainsLossesOnRemeasuringInvestmentsHeldAsAvailableForSale: 8,
    OtherUnrealizedGainsLosses: 9,
    OtherComponentsOfEquityOthers: 10,
    ChangesInEquity: 11,
    FinancialEffectsOfChangesInAccountingPolicies: 12,
    FinancialEffectsOfCorrectionsOfAccountingErrors: 13,
  },
  Statement410000Reference: {
    IssuedAndPaidUpShareCapitalMember: 1,
    SharePremiumAccountDiscountOnIssueOfShareMember: 2,
    RetainedEarningsMember: 3,
    OtherComponentsOfEquityMember: 4,
  },
  PeriodReferenceType: {
    Asof: 0,
    FromTo: 1,
  },
  FinanceUnitType: {
    Acturels: 0,
    Millions: 1,
    Billions: 2,
    Trillions: 3,
  },
  ChooseExportGeneralLedgerType: {
    AllAccount: 0,
    PhaseAccount: 1,
    ChooseAccount: 2,
  },
  AllocationTransactionItem: {
    None: 0,
    SameTransaction: 1,
    Custom: 2,
  },
  CreditNoteReasonType: {
    None: 0,
    PriceReductOfGoods: 1,
    PriceReductOfService: 2,
    ReturnOfGoods: 3,
    PayFineOrCompensation: 4,
    ReturnAdvancePayment: 5,
    ReturnOrExchangeRegistered: 6,
    ReturnOrExchangeCustomer: 7,
    CancelOfServiceAgreement: 8,
    CancelOfServiceProvided: 9,
    Other: 10,
  },
  DebitNoteReasonType: {
    None: 0,
    AddProduct: 1,
    AddSerview: 2,
    Other: 3,
  },
  ReturnStockType: {
    None: 0,
    Return: 1,
    NotReturn: 2,
  },
  ReduceDebtType: {
    None: 0,
    AllDebts: 1,
    Partially: 2,
  },
  CreateTransactionType: {
    Reference: 1,
    NotReference: 2,
  },
  SourceType: {
    PeakTax: 0,
    PeakAccount: 1,
    PeakPayRoll: 2,
  },
  SourceTypeProject: {
    PeakMini: 0,
    PeakExperience: 1,
    PeakApi: 2,
    PeakTax: 3,
    LineConnect: 4,
    PeakPayroll: 5,
    PeakAdmin: 6,
    PeakAsset: 7,
    FileVault: 8,
  },
  CreditNoteTypeOption: {
    None: 0,
    CreditedToReceivedBankAccount: 1,
    CreditedToAccountCode: 2,
  },
  BentoWebPaymentKeyType: {
    None: 0,
    PaymentMethod: 1,
    Bank: 2,
    Shipping: 3,
  },
  ShippingVatType: {
    None: 1,
    ZeroPercent: 2,
    SevenPercent: 3,
  },
  BentoWebRevenueBasisType: {
    CashBasis: 1,
    AccrualBasis: 2,
  },
  OptionsPriceChange: {
    Last10Times: 1,
    Last20Times: 2,
    Monthly: 3,
  },
  AllocationValueType: {
    Amount: 0,
    Percent: 1,
  },
  FetchDataType: {
    None: 0,
    ByOrderCode: 1,
    ByPeriod: 2,
  },
  EventActionDropdonwContact: {
    ShowModalAddContact: 1,
    CreateContactDefault: 2,
  },
  EventActionDropdonwProduct: {
    CreateProductDefault: 1,
    ShowModalAddProduct: 2,
  },
  ExportContactType: {
    None: 0,
    AccountReceivable: 1,
    AccountPayable: 2,
    Contact: 3,
  },
  OnboardingNewPeakType: {
    isSettingOrganization: 1,
    isSettingLogoAndStamp: 2,
    isAddNewUser: 3,
    isCreateBackAccount: 4,
    isCreateProduct: 5,
    isCreateContact: 6,
    isCreateReceipt: 7,
    isCreateInvoice: 8,
  },
  PeriodProfitLossType: {
    AddPeriod: 1,
    Compare: 2,
  },
  DateType: {
    Day: 1,
    Month: 2,
    Year: 3,
  },
  QRPaymentType: {
    None: 0,
    UploadQRCodeImage: 1,
    ConnectAPI: 2,
  },
  ApiQRPaymentType: {
    None: 0,
    Bank: 1,
    SCB: 2,
    PaySolutions: 3,
    Bay: 4,
    Bbl: 5,
    Beam: 6,
  },
  ImportBankStatementFormat: {
    Name: 0,
    Peak: 1,
    SCB: 2,
    KBANK: 3,
    BAY: 4,
    BBL: 5,
  },
  TapReconcileType: {
    Reconcile: 1,
    Pending: 2,
  },
  ReconcileTransactionType: {
    AccountingRecord: 1,
    RevenuesDocument: 2,
    ExpensesDocument: 3,
  },
  IndexTaskInsertMerchantList: {
    AddressInformation: 0,
    AccountCode: 1,
    ContactInformation: 2,
    ProductInformation: 3,
    PaymentChannel: 4,
    Invoice: 5,
    Receipt: 6,
    Expense: 7,
    PurchaseInventory: 8,
    Journal: 9,
  },
  CreateExpenseMerchantSampleEnum: {
    Expense: 0,
    LazadaSetBefore2MonthFromNow: 1,
    LazadaSet2MonthFromNow: 2,
  },
  SubscriptionType: {
    None: 0,
    OneTimePurchase: 1,
    AutoSubscription: 2,
  },
  PackagePaymentType: {
    None: 0,
    QRCode: 1,
    Transfer: 2,
    DebitCreditCard: 3,
  },
  StepPaymentPackage: {
    None: 0,
    SelectPackageInfo: 1,
    PaymentPackage: 2,
  },
  PaymentPackageTabType: {
    Package: 0,
    History: 1,
    CardInfo: 2,
  },
  CreditCardBrand: {
    None: 0,
    Visa: 1,
    MasterCard: 2,
    Jcb: 3,
    Other: 4,
  },
  ChargeTokenType: {
    CardToken: 0,
    KeyToken: 1,
  },
  TrackingGoogleFacebookType: {
    None: 0,
    AddToWishList: 1,
    StartTrial: 2,
    Subscribe: 3,
  },
  ReasonCancelSubscriptionType: {
    Others: 0,
    FunctionNotSupport: 1,
    TooComplicate: 2,
    StillInconvenientStudy: 3,
    NotImpressedServicesStaff: 4,
    WantSystemMoreStable: 5,
    PriceNotProper: 6,
    ChangeAccountingFirmOrProblemManpower: 7,
  },
  ECommerceReferenceProductType: {
    None: 0,
    ProductCode: 1,
    SKUShopee: 2,
  },
  RejectType: {
    None: 0,
    Void: 1,
    SendToDraft: 2,
  },
  DemoOrganizeGuideType: {
    None: 0,
    ViewCreateReceipt: 1,
    ViewCreateExpense: 2,
    ViewProfitLoss: 3,
  },
  SkuType: {
    PeakCode: -1,
    Other: 0,
    Shopee: 1,
    Lazada: 2,
    TikTokShop: 3,
  },
  SettingNumberType: {
    None: 0,
    PeakSuggestNumber: 1,
    OrderReferenceNumber: 2,
  },
  ProductConfigType: {
    None: 0,
    AccountCode: 1,
    ProductCode: 2,
    SKU: 3,
  },
  FilterReconcileType: {
    None: 0,
    ShowReconciled: 1,
    ShowNotReconciled: 2,
  },
  StockQueueStatusType: {
    None: 0,
    WaitingQueue: 1,
    OnProcess: 2,
    Error: 3,
  },
  SettingTaxInvoiceType: {
    None: 0,
    IssueTaxInvoice: 1,
    NotIssueTaxInvoice: 2,
    AutoIssueTaxInvoice: 3,
  },
  SettingTaxDocumentType: {
    None: 0,
    IssueTaxDocument: 1,
    NotIssueTaxDocument: 2,
    ManualIssueTaxInvoice: 3,
  },
  SettingTransactionTypeCanIssueTaxDocument: {
    None: 0,
    ReceiptOnly: 1,
    InvoiceAndReceipt: 2,
  },
  DatePeriodType: {
    ThisMonth: 1,
    LastMonth: 2,
    ThisYear: 3,
    Lastyear: 4,
    Custom: 5,
  },
  FilterReconcileType: {
    None: 0,
    ShowReconciled: 1,
    ShowNotReconciled: 2,
  },
  EDocumentType: {
    None: 0,
    Invoice: 1,
    InvoiceTaxInvoice: 2,
    DeliveryOrderTaxInvoice: 3,
    AbbreviatedTaxInvoice: 4,
    Receipt: 5,
    ReceiptTaxInvoice: 6,
    ReceiptAbbreviatedTaxInvoice: 7,
    TaxInvoice: 8,
    CreditNote: 9,
    DebitNote: 10,
    CancelDocument: 11,
  },
  SettingPartialQuotationEditType: {
    None: 0,
    CanEdit: 1,
    CanEditMoreThan: 2,
  },
  TapFinanceType: {
    Overview: 1,
    CashBank: 2,
    ChequeReceive: 3,
    ChequeIssue: 4,
    ExpenseClaim: 5,
    WithHeldTax: 6,
    WithHeldingTax: 7,
  },
  ContactUserRoleType: {
    None: 0,
    All: 1,
    ContactAccessAndAddContact: 2,
    ContactAccessAndEditContact: 3,
    ContactAccessAndDeleteContact: 4,
    ContactAccessAndExportContact: 5,
    ContactAccessAddAndEditContact: 6,
    ContactAccessAddAndDeleteContact: 7,
    ContactAccessAddAndExportContact: 8,
    ContactAccessEditAndDeleteContact: 9,
    ContactAccessEditAndExportContact: 10,
    ContactAccessDeleteAndExportContact: 11,
    AddAndEditContact: 12,
    AddAndDeleteContact: 13,
    AddAndExportContact: 14,
    AddEditAndDeleteContact: 15,
    AddEditAndExportContact: 16,
    AddDeleteAndExportContact: 17,
    EditAndDeleteContact: 18,
    EditAndExportContact: 19,
    AddEditDeleteAndExportContact: 20,
    DeleteAndExportContact: 21,
    DeleteExportAndEditContact: 22,
    ContactAccess: 23,
    AddContact: 24,
    EditContact: 25,
    DeleteContact: 26,
    ExportContact: 27,
    ContactAccessAddEditAndDeleteContact: 28,
    ContactAccessAddEditAndExportContact: 29,
    ContactAccessAddDeleteAndExportContact: 30,
    ContactAccessEditDeleteAndExportContact: 31,
  },
  StatementOfCashflowItemType: {
    netProfitLoss: 0,
    taxExpense: 1,
    depreciationAndAmortizationExpense: 2,
    financeCosts: 3,
    dividendsReceivedActivities: 4,
    interestReceived: 5,
    paidTaxExpense: 6,
    accountReceivable: 7,
    otherReceivables: 8,
    inventories: 9,
    taxAssetsAndRevenueReceivables: 10,
    otherAssets: 11,
    accountPayables: 12,
    otherPayables: 13,
    taxAndSocialSecurityLiabilities: 14,
    otherLiabilities: 15,
    provisionsForEmployeeBenefits: 16,
    otherProvisions: 17,
    otherCashFromOperatingActivities: 18,
    netCashFlowsFromOperatingActivities: 19,
    salesControlOfSubsidiaries: 20,
    salesOfNonControlInterests: 21,
    salesOfEquity: 22,
    salesOfInterestsJointVentures: 23,
    salesOfPropertyPlantEquipment: 24,
    salesOfIntangibleAssets: 25,
    salesOtherLongTermAssets: 26,
    salesOtherAssets: 27,
    repaymentOfAdvances: 28,
    dividendsReceivedInvesting: 29,
    interestReceivedInvesting: 30,
    purchaseControlInterests: 31,
    purchaseNonControlInterests: 32,
    purchaseOfEquity: 33,
    purchaseOfInterestsJointVentures: 34,
    purchaseOfPropertyPlantEquipment: 35,
    purchaseOfIntangibleAssets: 36,
    purchaseOtherLongTermAssets: 37,
    purchaseOtherAssets: 38,
    advancePayments: 39,
    otherCashFromInvestingActivities: 40,
    netCashFlowsFromInvestingActivities: 41,
    proceedsFromIssuingShares: 42,
    proceedsFromBorrowings: 43,
    ownersBuySharesBusiness: 44,
    paidForRepaymentsBorrowings: 45,
    dividendsPaid: 46,
    interestPaid: 47,
    otherFinanceCosts: 48,
    otherInOutflowsCashFinancingActivities: 49,
    netCashflowsFromfinancingActivities: 50,
    netCashEquivalents: 51,
    cashEquivalentsAtBeginningBalance: 52,
    cashEquivalentsAtEndingBalance: 53,
  },
  SettingPlatformType: {
    None: 0,
    OldPeak: 1,
    NewPeak: 2,
  },
  CreateJournalUserType: {
    UserCreatedDocument: 1,
    UserApprovedDocument: 2,
  },
  SettingPageType: {
    None: 0,
    OnlineView: 1,
    Detail: 2,
  },
  DocumentNumberConfigType: {
    Peak: 1,
    Provider: 2,
  },
  MenuTour: {
    Dashboard: 1,
    RevenueExpense: 2,
    DataStorage: 3,
    Account: 4,
    AllSettings: 5,
    AppCenter: 6,
    AppCenterLineConnectPR: 7,
    Congrats: 8,
  },
  DocumentTour: {
    None: 0,
    Receipt: 1,
    ReceiptCreateCustomer: 2,
    ReceiptCreateProduct: 3,
    ReceiptCreatePayment: 4,
    ReceiptCreateSaveDraft: 5,
    PrintReceipt: 6,
    Congrats: 7,
  },
  InAppTutorialType: {
    MenuTour: 0,
    DocumentTour: 1,
    Settings: 2,
  },
  inAppSuggestion: {
    inAppTutorial: "InAppTutorial",
    inAppManualGuide: "InAppManualGuide",
    inAppPeakExpSettings: "InAppPeakExpSettings",
  },
  FinanceCalendarType: {
    None: 0,
    Record: 1,
    Future: 2,
  },
  GetApiTableType: {
    Default: 1,
    Advance: 2,
    VeryAdvance: 3,
  },
  TableAdvancedSearcType: {
    Advance: 1,
    VeryAdvance: 2,
  },
  ReceiptCreateStatus: {
    CanNotCreateReceipt: -1,
    CanCreateReceipt: 0,
    CreatedReceipt: 1,
  },
  FilterETaxInvoiceType: {
    None: 0,
    Sent: 1,
    Await: 2,
  },
  JournalTableTypeId: {
    All: 0,
    Purchase: 1,
    Sales: 2,
    Payment: 3,
    Receive: 4,
    General: 5,
  },
  JournalTableViewStatus: {
    All: 0,
    AwaitRecord: 1,
    Draft: 2,
    Voided: 3,
    ShouldBeCheck: 4,
    AwaitAppove: 5,
    Appove: 6,
  },
  FileVaultTransactionType: {
    Expense: 1,
    PurchaseInventory: 2,
    PurchaseAsset: 3,
    Quotation: 4,
    Invoice: 5,
    Receipt: 6,
    Wht: 7,
  },
  UploadDocumentType: {
    Upload: 0,
  },
  FileDocumentType: {
    None: 0,
    Unspecified: 1,
    Expense: 2,
    Revenue: 3,
    WithheldTax: 4,
  },
  UploadDocumentReferenceType: {
    None: 0,
    Quotation: 1,
    Invoice: 2,
    Receipt: 3,
    WithholdingTax: 12,
  },
  DragAndDropFileImportType: {
    None: 0,
    ImportTransaction: 1,
    ImportProduct: 2,
    ImportContact: 3,
    ImportStatement: 4,
    ImportFileVault: 5,
  },
  CreateDocumentType: {
    NewForm: 1,
    OldForm: 2,
  },
  UploadDocumentTableView: {
    None: 0,
    UploadDate: 1,
  },
  VideoFeedback: {
    None: 0,
    Yes: 1,
    No: 2,
    Complete: 3,
    Submit: 4,
  },
  DocumentTourStatus: {
    Hide: 0,
    Show: 1,
    Edit: 1,
  },
  AttributesDescriptionRecurring: {
    None: 0,
    OrderOfIssuance: 1,
    DocumentNumber: 2,
    IssuedDateDDMMYYYY: 3,
    IssuedFullMonthNameTH: 4,
    IssuedFullMonthNameEN: 5,
    IssuedAbbreviatedMonthNameTH: 6,
    IssuedAbbreviatedMonthNameEN: 7,
    IssuedMonthMM: 8,
    IssuedYearAD: 9,
    IssuedYearBE: 10,
    DueDateDDMMYYYY: 11,
    DueDateFullMonthNameTH: 12,
    DueDateFullMonthNameEN: 13,
    DueDateAbbreviatedMonthNameTH: 14,
    DueDateAbbreviatedMonthNameEN: 15,
    DueDateMonthMM: 16,
    DueDateYearAD: 17,
    DueDateYearBE: 18,
  },
  BroadcastUserChannelType: {
    None: 0,
    AuthenticatedNotification: 1,
    DisconnectNotification: 2,
    UpdateNotificationList: 3,
    MasterDeleteNotificationById: 4,
    UpdateNotificationCount: 5,
    MasterGetNotificationListByMerchantId: 6,
    MasterGetNotificationCountByMerchantId: 7,
    DisconnectNotificationAllTab: 8,
    ReCreateTab: 9,
    MasterSetNotificationIsSeenAll: 10,
  },
  AuthenticatedNotification: {
    Success: 1,
    Failed: 2,
  },
  BroadcastTabChannelType: {
    None: 0,
    MasterTabClose: 1,
  },
  TabList: {
    LatestUpdate: 1,
    PEAKMission: 2,
    FeatureDiscovery: 3,
  },
  OpenType: {
    None: 0,
    Modal: 1,
    Link: 2,
  },
  CoverType: {
    Image: 1,
    Youtube: 2,
  },
  FeatureDiscoveryTag: {
    All: 0,
    ForYou: 1,
    Automated: 2,
    Accountant: 3,
    Management: 4,
    Payroll: 5,
    Ecommerce: 6,
  },
  FeatureDiscoveryBusinessType: {
    All: 0,
    AccountingFirmOrFreelanceAccountant: 1,
    RetailAndTrade: 9,
    Services: 10,
  },
  FeatureDiscoveryRole: {
    All: 0,
    BusinessOwner: 1,
    Accountant: 5,
    Employee: 6,
    AccountingFirm: 7,
  },
  TableReconcileSortBy: {
    Date: 1,
    Amount: 2,
  },
  ContactFinanceType: {
    All: 0,
    InFlow: 1,
    OutFlow: 2,
  },
};
